import React, { Component } from "react";
import ReactDOM from "react-dom";
import { BaseTable, features, TablePipeline } from "ali-react-table";
import isEqual from "lodash/isEqual";
import QRCode from "qrcode.react";
import Barcode from "react-barcode";
import BsyTurnPage from "../BsyTurnPage";
import BsyCheckBox from "../BsyCheckBox";
import BsyThumbList from "../BsyThumbList";
import BsyFileThumbList from "../BsyFileThumbList";
import BsyUserThumbList from "../BsyUserThumbList";
import BsyDeptThumbList from "../BsyDeptThumbList";
import CircularJSON from "circular-json";

import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import { BsyConfig } from "../../global/BsyConfig";
import BsySLoading from "../BsySLoading";
import BsyMsgBubble from "../BsyMsgBubble";
import { TriggerComboCheckPane } from "../BsySelectCheckBox";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyTextEditor from "../BsyTextEditor";
import BsyNumber from "../BsyNumber";
import BsyDateTime from "../BsyDateTime";
import BsySubformRadioGroup from "../BsySubformRadioGroup";
import BsySubformCheckboxGroup from "../BsySubformCheckboxGroup";
import BsyComboBox from "../BsyComboBox";
import BsyComboCheckBox from "../BsyComboCheckBox";
import BsySelectUser from "../BsySelectUser";
import BsySelectUserGroup from "../BsySelectUserGroup";
import BsySelectDept from "../BsySelectDept";
import BsySelectDeptGroup from "../BsySelectDeptGroup";
import BsySubformAddress from "../BsySubformAddress";
import BsySubformFileUpload from "../BsySubformFileUpload";
import BsySubformImageUpload from "../BsySubformImageUpload";
import BsySubformSignature from "../BsySubformSignature";
import BsyFormDataManager from "../BsyFormDataManager";
import BsyExportPane from "../BsyExportPane";
import BsyDialog from "../BsyDialog";
import BsySubformTextArea from "../BsySubformTextArea";
import BsySubformTextEditor from "../BsySubformTextEditor";
import BsyButton from "../BsyButton";
import BsyRadioBox from "../BsyRadioBox";
import BsyMaskLayer from "../BsyMaskLayer";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import BsyFormPane from "../BsyFormPane";
import TextWidgetFilter from "../../utils/WidgetFilter/TextWidgetFilter";
import NumberWidgetFilter from "../../utils/WidgetFilter/NumberWidgetFilter";
import DatetimeWidgetFilter from "../../utils/WidgetFilter/DatetimeWidgetFilter";
import ComboCheckWidgetFilter from "../../utils/WidgetFilter/ComboCheckWidgetFilter";
import TextareaWidgetFilter from "../../utils/WidgetFilter/TextareaWidgetFilter";
import AddressWidgetFilter from "../../utils/WidgetFilter/AddressWidgetFilter";
import UserWidgetFilter from "../../utils/WidgetFilter/UserWidgetFilter";
import DeptWidgetFilter from "../../utils/WidgetFilter/DeptWidgetFilter";
import DeptGroupWidgetFilter from "../../utils/WidgetFilter/DeptGroupWidgetFilter";
import UserGroupWidgetFilter from "../../utils/WidgetFilter/UserGroupWidgetFilter";
import SignatureWidgetFilter from "../../utils/WidgetFilter/SignatureWidgetFilter";
import FileListWidgetFilter from "../../utils/WidgetFilter/FileListWidgetFilter";
import BsyTagList from "../BsyTagList";
import { dayjsUtils } from "../../utils/dayjsUtils";
import { getAfterSuffix } from "../../utils/getAfterSuffix";

class BsyDataTable extends Component {
  static defaultProps = {
    url: "/data/report_datatable_list",
    asyncExportURL: "/data/report_datatable_export",
    columns: [],
    isBackup: false,
    multipleChoice: false,
    level2Menu: false,
    dataSource: [],
    popupFormPath: [],
    origin: "", // 用于判断某些特殊情况,空为 为数据管理
    sort: [],
    rowOrder: {},
    componentAttr: {},
    title: "",
    FILTER_METHOD: {
      EQ: "eq",
      NE: "ne",
      ALL: "all",
      IN: "in",
      NIN: "nin",
      LK: "like",
      ULK: "unlike",
      EP: "empty",
      NEP: "not_empty",
      GT: "gt",
      GTE: "gte",
      LT: "lt",
      LTE: "lte",
      RG: "range",
    },
    pageSize: 20,
    sortIncludedField: [
      "_id",
      "text",
      "number",
      "radiogroup",
      "datetime",
      "combo",
      "sn",
      "formula",
      "flowstate",
      "flowState",
      "flowdecision",
    ],
    autoLoad: true,
    mountAutoLoad: true, //渲染完成后立即加载
    showFields: null,
    showFieldsMeta: null,
    fields: [],
    formItems: [],
    StoregetKey: "dashboardColSizeMap",
    sortKey: "dashboardSorts",
    hasCount: true,
    widgetId: "",
    ignoreOptAuth: false, //忽略权限，数据管理使用
    ignoreValidate: false, //忽略权限，数据管理使用
    menu: {
      set: [],
    },
    is_dock_form: false,
    authGroupId: null,
    ignoreAuth: !1, //数据管理
    onCheckHook: null,
    onCheckRow: null,
    hasAutoHeight: true, //调整行高
    hasAutoHeightCache: true,
    autoHeight: "adaptive", //low mid height adaptive
    hasRowClick: true,
    enableRowEdit: false, // 行编辑
    quickEdit: false,
    noRely: false,
    search: null,
    checkStatus: "check",
    // 记录多页选的数据
    saveMultiPageData: false,
  };

  constructor(props) {
    super(props);

    this._getFiels(
      props.appId,
      props.entryId,
      props.widgetId,
      props.authGroupId,
      props.fields
    );

    let useVirtual = false;
    if (this.fields.length > 30) {
      useVirtual = true;
    } else {
      let subn = 0;
      this.fields.map((field) => {
        if (field.type === "subform") {
          subn += field.items.length;
        }
      });
      if (subn > 5) {
        useVirtual = true;
      }
    }

    let level2Menu = props.level2Menu || props.multipleChoice || false;
    this.state = {
      columns: props.columns,
      url: props.url,
      is_dock_form: props.is_dock_form,
      limit: props.pageSize || 20,
      skip: 0,
      rowOrder: props.rowOrder,
      sort: props.defaultSort ? props.defaultSort : props.sort,
      widgetId: props.widgetId,
      fields: props.fields,
      formulas: props.formulas,
      forms: props.forms,
      filter: props.filter,
      appId: props.appId,
      entryId: props.entryId,
      componentAttr: props.componentAttr,
      formItems: props.formItems,
      ignoreAuth: props.ignoreAuth,
      optAuth: props.optAuth, //权限 用于表单直接编辑的时候的权限操作
      count: 0,
      allCount: 0,
      filterCount: 0,
      hasShowSubform: false,
      isLoading: false,
      pipelineState: {}, // pipelineState 的默认值必须为一个对象,
      pipelineMode: "",
      isCheckAll: false,
      authGroupId: props.authGroupId,
      sortIncludedField: props.sortIncludedField,
      error: 0,
      title: props.title || props.text,
      autoLoad: props.autoLoad,
      showFields: this._getShowFieldMap(),
      showFieldsMeta: this._getColSizeMap(),
      StoregetKey: props.StoregetKey,
      sortKey: props.sortKey,
      level2Menu: level2Menu,
      menu: this.toMenu(this.props.menu),
      chartType: "data_table",
      isBackup: props.isBackup,
      hasAutoHeight: props.hasAutoHeight, //调整行高
      autoHeight: props.autoHeight, //low mid height
      useVirtual: useVirtual,
      loadMode: "",
      enableRowEdit: props.enableRowEdit,
      quickEdit: props.quickEdit,
      tablekey: "table-0",
      checkStatus: props.checkStatus,
      saveMultiPageData: props.saveMultiPageData,
    };

    this.CELLEDITSTATE = {
      0: "NORMAL",
      1: "LOADING",
      2: "EDITING",
      3: "FIELD_ERROR",
      4: "SUBMIT_ERROR",
      5: "SUCCESS",
      NORMAL: 0,
      LOADING: 1,
      EDITING: 2,
      FIELD_ERROR: 3,
      SUBMIT_ERROR: 4,
      SUCCESS: 5,
    };

    this.popupFormPath = [...this.props.popupFormPath];
    this.fieldMap = {};
    for (let i = 0; i < props.fields.length; i++) {
      let f = props.fields[i];
      this.fieldMap[f.tag] = f;
    }

    // console.log('BsyDataTable constructor');
    this.lastsort = []; //记录历史最后一次的的详细情况，防止同样的规则也重复操作
    this.lastcolumnResize = []; //记录历史最后一次的的详细情况，防止同样的规则也重复操作

    this.lockColunIndex = 0;
    this.subofrmMap = [];
    this.popupFormPath = [...props.popupFormPath];
    this.filterParam = null;
    this.element = React.createRef();
    this.scrollLeft = 0;
    this.stickyElement = React.createRef();
    this.stickyMin = null;
    this.stickyMax = null;
    this.isDashFull = props.isDash;
    this.getTableKey();
    this.platform = BsyUtils.detectOS();
    this.ignoreDataId = []; //当遇到checkHook 回调的时候，此属性才生效 主要用于记录被忽略的ID，用于全选按钮的时候使用
    // this.sorts = props.sort ? [...props.sort] : [];//记录map的结构

    this.tableRef = React.createRef();

    this.getSortMap();
    this.getWidgetMap(); //用于表单修改属性使用
    this.selectDataId = BsyUtils.isObjectEmpty(props.selectDataId)
      ? []
      : [...props.selectDataId];
    // 记录选择的时候的具体数据，主要用于数据加载，多页的时候选择数据使用
    this.selecteData = [];
    this.checkRefMap = {};
    this.formDateCache = {}; //记录表单的数据 通过_id 为key
    this.editStatus = this.CELLEDITSTATE.NORMAL; //
    if (props.quickEdit) {
      this.dataManager = new BsyFormDataManager({
        type: props.type,
        optAuth: props.optAuth,
        element: this.element,
        items: props.formItems,
        appId: props.appId,
        formId: !BsyUtils.isObjectEmpty(props.forms)
          ? props.forms[0]
          : props.entryId,
        entryId: props.entryId,
        dataTable: this, //
        authGroupId: props.authGroupId,
        ignoreAuth: props.ignoreAuth,
        noRely: props.noRely,
        extDashData: props.extDashData,
        popupFormPath: !props.origin
          ? []
          : this.popupFormPath.concat({
            appId: this.props.appId,
            entryId: this.props.entryId,
            formId: this.props.forms[0],
            widgetId: this.props.widgetId,
          }),
      });

      //在支持表格编辑的情况下，需要动态更新数据源，否则会存在BUG
      this.dataSourceCache = [];
      this.cacheStatus = false;
      // 格式如何下，当数据update后，缓存中的数据自动清理掉
      // id：{subform:xxx,subform:xxx,subform:xxx}
    }
  }

  //过滤子表单中一些为空的数据
  getSubformOrgData = (data) => {
    let subform = [];
    BsyUtils.forEach(data, (index, rowData) => {
      let isEmpty = true;
      BsyUtils.forEach(rowData, (key, value) => {
        if (key != "id") {
          if (!BsyUtils.isObjectEmpty(value)) {
            isEmpty = false;
          }
        }
      });
      if (!isEmpty) {
        subform.push({ ...rowData });
      }
    });
    return subform;
  };

  // 给快捷编辑，update后获取单行的值使用
  getReadDataExt = () => {
    let filter = this.getFilterData(this.filterParam);

    if (this.props.origin === "report") {
      return {
        widgetId: this.props.widgetId,
        filter,
        jsplatform: "React",
        appId: this.props.appId,
        entryId: this.props.entryId,
        refAppId:
          this.props.forms[0].indexOf("@") > -1
            ? this.props.forms[0].split("@")[1]
            : undefined,
      };
    }
    return {
      filter,
      jsplatform: "React",
    };
  };

  mergeDataToTable = (rowData, id) => {
    let tmpdata = { ...rowData };

    if (!rowData) {
      this.resultData.data = this.resultData.data.filter((it) => {
        return it._id !== id;
      });
      this.newDataSource = this.transformDataSource(
        [...this.resultData.data],
        this.header
      );
      this.hasCachedData = true;
      return;
    }

    if (
      this.props.type === "data_table" ||
      this.state.chartType === "data_table"
    ) {
      BsyUtils.forEach(this.header, (index, col) => {
        if (rowData.hasOwnProperty(col.name)) {
          tmpdata[col.tag] = rowData[col.name];
        }
      });
    }

    //返回最新的后台数据，合并到当前表格
    for (let i = 0; i < this.resultData.data.length; i++) {
      if (this.resultData.data[i]._id === tmpdata._id) {
        // let subvalueMap = {};
        // BsyUtils.forEach(this.widgetMap, (key, widget) => {
        //   if (widget.type === "subform") {
        //     let name = widget.tag || widget.widgetName;
        //     const subvalue = this.resultData.data[i][name];
        //     if (subvalue) {
        //       const newvalue = subvalue.map((e) => {
        //         const index = tmpdata[name].findIndex(
        //           (item) => item.id === e.id
        //         );
        //         return tmpdata[name][index];
        //       });
        //       subvalueMap[name] = [...newvalue];
        //     }
        //   }
        // });

        this.resultData.data[i] = {
          ...this.resultData.data[i],
          ...tmpdata,
          // ...subvalueMap,
        };
      }
    }
    this.newDataSource = this.transformDataSource(
      [...this.resultData.data],
      this.header
    );
    this.hasCachedData = true;
  };

  getTableScrollTop = () => {
    if (!this.element.current) {
      return 0;
    }
    return this.element.current.querySelector(".chart-data-border").scrollTop;
  };

  getTableScrollLeft = () => {
    if (!this.element.current) {
      return 0;
    }
    return this.element.current.querySelector(".art-sticky-scroll").scrollLeft;
  };

  //把子表单中的数据合并到数据表中，并刷新界面
  mergeSubformDataToTable = () => {
    this.scrollLeft = this.getTableScrollLeft();
    this.scrollTop = this.getTableScrollTop();

    this.setState(
      {
        dataSource: this.newDataSource,
        tablekey: "table-" + new Date().getTime(),
      },
      () => {
        this.resetEditStatus();
        if (this.element.current && this.scrollLeft > 0) {
          let dcd = this.element.current.querySelector(".art-sticky-scroll");
          dcd.scrollLeft = this.scrollLeft + 1;
        }
        if (this.element.current && this.scrollTop > 0) {
          let dcd = this.element.current.querySelector(".chart-data-border");
          dcd.scrollTop = this.scrollTop;
        }
      }
    );
  };

  //实时更新当前操作的数据到缓存中，解决行列拖动，数据刷新问题
  updateDataSourceCache = (id, widget, value, subformRow) => {
    for (let i = 0; i < this.resultData.data.length; i++) {
      if (this.resultData.data[i]._id === id) {
        if (widget.subform) {
          subformRow = subformRow || 0;
          if (!this.resultData.data[i][widget.subform]) {
            this.resultData.data[i][widget.subform] = [];
          }
          if (!this.resultData.data[i][widget.subform][subformRow]) {
            this.resultData.data[i][widget.subform].push({});
          }
          this.resultData.data[i][widget.subform][subformRow][
            widget.tag || widget.name
          ] = value;
        } else {
          this.resultData.data[i][widget.tag || widget.name] = value;
        }
      }
    }
    this.newDataSource = this.transformDataSource(
      [...this.resultData.data],
      this.header
    );
    this.hasCachedData = true;
  };

  getWidgetMap = (items) => {
    let { formItems, fields } = this.state;
    formItems = !BsyUtils.isObjectEmpty(formItems) ? formItems : fields;
    let that = this;
    this.widgetMap = {};
    if (!BsyUtils.isObjectEmpty(this.widgetMap)) {
      return;
    }

    if (BsyUtils.isObjectEmpty(formItems)) {
      return;
    }

    BsyUtils.forEach([...formItems], function (a1, b1) {
      if (b1.widget) {
        if (b1.widget.type === "subform") {
          that.widgetMap[b1.widget.widgetName] = { ...b1.widget };
          BsyUtils.forEach(b1.widget.items, function (a2, b2) {
            that.widgetMap[
              [b1.widget.widgetName, b2.widget.widgetName].join(".")
            ] = { ...b2.widget, subform: b1.widget.widgetName };
          });
        } else {
          that.widgetMap[b1.widget.widgetName] = { ...b1.widget };
        }
      } else {
        that.widgetMap[b1.tag] = { ...b1 };
        that.widgetMap[b1.name] = { ...b1 };
        if (b1.type === "subform") {
          BsyUtils.forEach(b1.items, function (a2, b2) {
            that.widgetMap[[b1.name, b2.name].join(".")] = { ...b2 };
          });
        }
      }
    });
  };

  getSortMap = (sort) => {
    let that = this;
    this.sortMap = {}; //记录排序字段当前的结构
    BsyUtils.forEach(sort, (k, v) => {
      BsyUtils.forEach(v, (k1, v1) => {
        that.sortMap[k1] = v1;
      });
    });
  };

  getSortState = (val) => {
    switch (val) {
      case 1: {
        return "asc";
      }
      case -1: {
        return "desc";
      }
      case 0:
      default: {
        return "none";
      }
    }
  };

  _getFiels = (appId1, entryId1, widgetId1, authGroupId, fields) => {
    let CachedFields =
      this.props.forms.length && this.props.forms[0]
        ? this._getCachedFields(appId1, entryId1, widgetId1, authGroupId)
        : undefined;
    this.allFields = [];
    let CachedFieldsNull = [];
    fields.map((data, index) => {
      if (!data.detailOnly) {
        this.allFields.push(data);
      }
      if (!data.detailOnly) {
        CachedFieldsNull.push(data);
      }
    });

    this.fields =
      CachedFields === undefined
        ? this.props.origin === "report"
          ? this.allFields.filter((it) => {
            return it.name !== "label";
          })
          : CachedFieldsNull.filter((it) => {
            return it.name !== "label";
          })
        : CachedFields;
  };

  getTableKey = () => {
    this.tableKey = "datatable" + window.FX.STATIC.zIndex++;
  };

  toMenu = () => {
    let mm = [];
    const { menu } = this.props;
    for (let i = 0; i < menu.set.length; i++) {
      let w =
        menu.set[i].mode === "text"
          ? BsyUtils.getElTextWidth(menu.set[i].name, "12px") + 10 + 4
          : 24 + 4;
      // console.log('toMenu ' + i, w)
      mm.push({
        ...menu.set[i],
        width: w,
      });
    }
    return [...mm];
  };

  _getCachedFields = (appId1, entryId1, widgetId1, authGroupId) => {
    return (
      BsyUtils.Store.get(
        this._getShowFieldKey(appId1, entryId1, widgetId1, authGroupId)
      ) || undefined
    );
  };

  _updateCachedFields = () => {
    const { appId, entryId, widgetId, authGroupId } = this.state;
    BsyUtils.Store.set(
      this._getShowFieldKey(appId, entryId, widgetId, authGroupId),
      this.fields
    );

    if (this.props.onReload) {
      this.props.onReload();
    }
  };
  _setFilterParam = (t) => {
    BsyUtils.isNull(t) || (this.filterParam = t);
  };

  getColorFilterConfig = (field) => {
    const { bgColorFilter } = this.props;

    this.bkColor = null;
    this.bkColorKey = null;
    this.bkColorType = null;
    this.bgColorFilter = null;

    if (!field) {
      if (
        bgColorFilter &&
        bgColorFilter.length > 0 &&
        bgColorFilter[0].options
      ) {
        this.bkColor = bgColorFilter[0].options;
        this.bkColorKey = bgColorFilter[0].tag;
        this.bkColorType = bgColorFilter[0].type;
        this.bgColorFilter = { ...bgColorFilter[0] };
      }
    } else {
      if (field.colorText) {
        this.bkColor = field.colorText;
        this.bkColorKey = field.tag;
        this.bkColorType = field.type;
        this.bgColorFilter = { ...field };
      }
    }
  };

  setPipelineState = (updater) => {
    // this.setPipelineState 被调用时，第一个参数 updater 是一个函数
    // updater 接受原来的 pipelineState，返回新的 pipelineState
    this.setState(
      (prev) => ({
        pipelineState: updater(prev.pipelineState),
      }),
      () => {
        // console.log(this.state.pipelineState)

        //处理字段排序
        // if (this.state.pipelineState.sort) {

        //   if (BsyUtils.compare(this.lastsort, this.state.pipelineState.sort)) {
        //     return
        //   } else {
        //     this.lastsort = this.state.pipelineState.sort;
        //   }
        //   this._updateSort(this.state.pipelineState.sort)
        // }

        //已选择数据
        if (
          this.state.pipelineState.multiSelect &&
          this.state.pipelineState.multiSelect.value
        ) {
          this.selectDataId = [...this.state.pipelineState.multiSelect.value];
        }

        // console.log(this.state.pipelineState)
      }
    );
  };

  resetEditStatus = () => {
    this.hasCachedData = false;
    this.newDataSource = [];
    this.geditCell = null;
    this.currentTime = null;
    this.editStatus = this.CELLEDITSTATE.NORMAL;
    if (this.dataManager) {
      this.dataManager.reset();
    }
  };

  highlighterText = (text, widget) => {
    const { search } = this.state;
    let keyword = "";

    if (!search) {
      return text;
    }

    let field = widget.name;
    if (widget.subform) {
      field = [widget.subformWidgetName || widget.subform, field].join(".");
    }

    if (this.highlightFields && BsyUtils.isArray(this.highlightFields)) {
      //匹配高亮字段
      if (!this.highlightFields.includes(field)) {
        return text;
      }
    }

    if (search && search.keywords && search.keywords.length > 0) {
      keyword = search.keywords[0];
      return BsyUtils.highlighterText(keyword, text);
    } else {
      return text;
    }
  };

  transformData = (n, d) => {
    const { skip, limit } = this.state;
    this.getTableKey();
    let res = { ...this.resultData };
    this.getWidgetMap();
    this.reftype = res.reftype;
    this.highlightFields = res.highlightFields;
    this.subofrmMap = [];
    this.header = res.header;
    this.lockColunIndex = 0; //计算冻结了多少字段
    this.locksubform = "";
    this.getColorFilterConfig();
    let useVirtual = this.checkUseVirtual(res);
    //处理背景颜色
    const newD = res.data.map((dd, index) => {
      let it = { ...dd };

      if (this.props.widgetId.indexOf("datatableDataLoad") > -1) {
        //数据加载的ID需要单独处理
        if (this.reftype == "etl_table" || this.reftype == "aggregate_table") {
          it._id = `datatableDataLoad-${skip * limit + index}`; //"datatableDataLoad" + "-" + ;
          // 前端构建的id，实际上是会产生问题，因为筛选条件的原因，不同条件下，同ID对应的数据不一致 ？？？？？？ 2024 06 10 波波
          this.selecteData = []; // 数据视图 聚合表来源不支持分页多选的效果
        }
      } else {
        if (this.reftype == "etl_table" || this.reftype == "aggregate_table") {
          it._id = `${this.reftype}-${skip * limit + index}`; // 聚合表，数据视图的ID一致
        }
      }

      let s = this._check_data_bkcolor(dd);
      if (s.length === 2) {
        it.background = "rgb(" + s[0] + ")";
        it.color = "rgb(" + s[1] + ")";
      }
      return it;
    });

    const header = this.transformColumns(res.header);
    const data = this.transformDataSource(newD, res.header);

    this.stickyMin = null;
    this.stickyMax = null;

    let lockColWidth = 0;

    let readHeader = (dd) => {
      for (let i = 0; i < dd.length; i++) {
        if (dd[i].children) {
          readHeader(dd[i].children);
        } else {
          if (dd[i].lock) {
            lockColWidth += dd[i].width;
          }
        }
      }
    };
    let resetHeaderLock = (dd) => {
      for (let i = 0; i < dd.length; i++) {
        if (dd[i].children) {
          resetHeaderLock(dd[i].children);
        } else {
          if (dd[i].lock) {
            dd[i].lock = false;
          }
        }
      }
    };

    readHeader(header);
    //如果冻结的宽超过了，整个表的面板 就按普通的方式展示
    if (
      this.element.current &&
      lockColWidth + 20 > this.element.current.offsetWidth
    ) {
      resetHeaderLock(header);
    }
    this.resetEditStatus();
    let obj = {
      tablekey: "table-" + new Date().getTime(),
      useVirtual: useVirtual,
      columns: header,
      dataSource: data,
      dataEmpty: false,
      // selectDataId: [],
      isCheckAll: false,
      pipelineState: {
        ...this.state.pipelineState,
        multiSelect: {
          lastKey: "",
          value: [],
        },
      },
    };
    if (!this.props.hasCount) {
      obj.count = res.count;

      let d = this.getFilterData(this.filterParam);
      let seach = this.props?.getSearchData?.(); // 快捷搜索的值会影响allCount
      if (d && d.cond && d.cond.length > 0) {
        obj.filterCount = res.count;
      } else {
        if (!seach) {
          obj.allCount = res.count;
        }
      }
    }

    this.setState(obj, () => {
      if (this.props.onLoadSuccess) {
        this.props.onLoadSuccess(res, n, d);
      }

      setTimeout(() => {
        this.hasXScroll();
        let current = this.element.current;
        if (this.state.loadMode === "goPage") {
          if (current) {
            if (
              this.element.current &&
              this.element.current.querySelector(".chart-data-border")
            )
              this.element.current.querySelector(
                ".chart-data-border"
              ).scrollTop = 0;
          }
        }
        if (current) {
          let dcd = this.element.current.querySelector(".art-sticky-scroll");
          if (this.element.current && this.scrollLeft > 0) {
            dcd.scrollLeft = this.scrollLeft + 1;
          }
          if (dcd.style.display != "none") {
            this.element.current.classList.add("hasScrollX");
          }
        }

        this.setState({
          isLoading: false,
          loadMode: "",
        });
      }, 10);
    });
  };

  //检查 是否要开启虚拟dom 子表单的锅
  checkUseVirtual = (data) => {
    const { useVirtual } = this.state;
    let tmp = useVirtual;
    if (tmp) {
      return tmp;
    }
    let subs = [];
    for (let i = 0; i < data.header.length; i++) {
      if (data.header[i].type == "subform") {
        subs.push(data.header[i].tag || data.header[i].name);
      }
    }
    //有子表单
    if (subs.length && data.data.length >= 50) {
      return true;
    }

    for (let i = 0; i < data.data.length; i++) {
      let element = data.data[i];
      for (let index = 0; index < subs.length; index++) {
        const sub = subs[index];
        if (element.hasOwnProperty(sub) && element[sub]) {
          if (element[sub].length > 30) {
            return true;
          }
        }
      }
    }
    return useVirtual;
  };

  loadData = (n, d, s) => {
    const {
      url,
      limit,
      skip,
      fields,
      filter,
      sort,
      appId,
      entryId,
      widgetId,
      isLoading,
      isBackup,
      search,
      forms,
      bgColorFilter,
      dynamicField,
      rowOrder,
      componentAttr,
      top,
      widgetName,
    } = this.state;

    let autoload = this.props.autoLoad;
    if (this.props.onIsAutoLoad) autoload = this.props.onIsAutoLoad();

    if (!autoload) {
      this.setState(
        {
          dataEmpty: true,
        },
        () => {
          this.hasXScroll();
        }
      );
      return;
    }

    if (isLoading) {
      return;
    }

    let st = {
      isLoading: true,
      skip: skip,
    };

    if (!BsyUtils.isObjectEmpty(s)) {
      st.skip = s;
    }
    this.isDashFull = n;
    this.setState(st, () => {
      this._updateSortsMap(sort);

      //自定义获取数据
      if (this.props.onDataGet) {
        this.props.onDataGet(
          url,
          {
            limit: limit,
            skip: st.skip * limit,
            fields: fields,
            sort: sort,
            appId: appId,
            entryId: entryId,
            widgetId: widgetId,
            search: !search ? undefined : search,
            hasCount: false,
            isCountOnly: false,
            filter: this.getFilterData(this.filterParam),
            isBackup: isBackup ? true : undefined,
            popupFormPath: this.popupFormPath,
            authGroupId: this.props.authGroupId,
            jsplatform: this.props.jsplatform,
          },
          (res) => {
            if (
              this.element.current &&
              this.element.current.querySelector(".art-sticky-scroll")
            )
              this.scrollLeft =
                this.element.current.querySelector(
                  ".art-sticky-scroll"
                ).scrollLeft;

            if (res.data.hasOwnProperty("code") && res.data.code === 3000) {
              //onConfigError
              if (this.props.onConfigError) {
                this.props.onConfigError(res.data);
              }
              if (this.props.onLoadFail) {
                this.props.onLoadFail(n, d);
              }
              return;
            }
            this.resultData = { ...res.data };
            this.transformData(n, d);
          }
        );
        return;
      }
      let a = {};

      if (url === "/data/formdataload") {
        a = {
          widgetAssistId: widgetId,
          widget: window.$.extend(
            {
              fields: fields,
              forms: forms,
              filter: this.getFilterData(this.filterParam, "dataloadwidget"),
              hasHeader: !0,
              bgColorFilter: bgColorFilter,
              dynamicField: dynamicField,
            },
            componentAttr
          ),
          appId: appId,
          entryId: entryId,
          filter: this.getFilterData(this.filterParam),
          sort: sort,
          skip: skip * limit,
          limit: limit,
          rowOrder: rowOrder,
          top: top,
          hasCount: false,
          isCountOnly: false,
          popupFormPath: this.popupFormPath,
        };
      } else {
        a = {
          limit: limit,
          skip: st.skip * limit,
          fields: fields,
          sort: sort,
          appId: appId,
          entryId: entryId,
          widgetId: widgetId,
          search: !search ? undefined : search,
          hasCount: false,
          isCountOnly: false,
          filter: this.getFilterData(this.filterParam),
          isBackup: isBackup ? true : undefined,
          popupFormPath: this.popupFormPath,
          authGroupId: this.props.authGroupId,
          jsplatform: this.props.jsplatform,
          extDashData: this.props.extDashData,
        };
      }
      React.axios(
        url,
        {
          ...a,
          env: this.props.env || undefined,
        },
        { dashMode: n, autoShowMsg: this.props.env === "dashboard" }
      )
        .then((res) => {
          if (
            this.element.current &&
            this.element.current.querySelector(".art-sticky-scroll")
          )
            this.scrollLeft =
              this.element.current.querySelector(
                ".art-sticky-scroll"
              ).scrollLeft;

          if (res.data.hasOwnProperty("code") && res.data.code === 3000) {
            //onConfigError
            if (this.props.onConfigError) {
              this.props.onConfigError(res.data);
            }
            if (this.props.onLoadFail) {
              this.props.onLoadFail(n, d);
            }
            return;
          }
          // this.logtime = new Date().getTime();

          this.resultData = { ...res.data };
          this.transformData(n, d);
          // this.logtimenow = new Date().getTime();
          // console.log("transformData ",(this.logtimenow - this.logtime))
        })
        .catch((res) => {
          if (this.props.onConfigError) {
            if (res.status) {
              this.props.onConfigError(res.data);
            }
          }
          if (this.props.onLoadFail) {
            this.props.onLoadFail(n, d);
          }
          console.error(res);
          this.setState({ isLoading: false });
        });
    });
  };

  loadDataCount = (n, d) => {
    const {
      url,
      limit,
      skip,
      fields,
      sort,
      appId,
      entryId,
      widgetId,
      search,
      forms,
      bgColorFilter,
      dynamicField,
      rowOrder,
      componentAttr,
      top,
      widgetName,
    } = this.state;


    let autoload = this.props.autoLoad;
    if (this.props.onIsAutoLoad) autoload = this.props.onIsAutoLoad();

    if (!autoload) {
      return;
    }

    let a = {};

    if (url === "/data/formdataload") {
      a = {
        widgetAssistId: widgetId,
        widget: window.$.extend(
          {
            fields: fields,
            forms: forms,
            filter: this.getFilterData(this.filterParam, "dataloadwidget"),
            hasHeader: !0,
            bgColorFilter: bgColorFilter,
            dynamicField: dynamicField,
          },
          componentAttr
        ),
        appId: appId,
        entryId: entryId,
        filter: this.getFilterData(this.filterParam),
        sort: sort,
        skip: skip * limit,
        limit: limit,
        rowOrder: rowOrder,
        top: top,
        hasCount: true,
        isCountOnly: true,
        popupFormPath: this.popupFormPath,
      };
    } else {
      a = {
        limit: limit,
        skip: skip * limit,
        fields: fields,
        search: !search ? undefined : search,
        sort: sort,
        appId: appId,
        entryId: entryId,
        widgetId: widgetId,
        hasCount: true,
        isCountOnly: true,
        filter: this.getFilterData(this.filterParam),
        popupFormPath: this.popupFormPath,
        jsplatform: this.props.jsplatform,
      };
    }
    React.axios(
      url,
      {
        ...a,
        env: this.props.env || undefined,
      },
      { dashMode: n, autoShowMsg: this.props.env === "dashboard" }
    )
      .then((res) => {
        if (res.data.hasOwnProperty("code") && res.data.code === 3000) {
          return;
        }

        let obj = { count: res.data.count };
        let d = this.getFilterData(this.filterParam);
        let seach = this.props?.getSearchData?.(); // 快捷搜索的值会影响allCount
        if (d && d.cond && d.cond.length > 0) {
          obj.filterCount = res.count;
        } else {
          if (seach) {
            obj.allCount = res.count;
          }
        }

        this.setState(obj);
      })
      .catch((res) => {
        console.error(res);
      });
  };

  reload = (options) => {
    if (options && Array.isArray(options.sort)) {
      this.getSortMap(options.sort);
    }
    this.resetEditStatus();
    this.setState(
      {
        ...this.state,
        ...options,
      },
      () => {
        this.loadWidget();
      }
    );
  };

  componentDidMount() {
    // const { appId, entryId, widgetId } = this.state;
    let that = this;
    if (this.props.getContext) {
      this.props.getContext(this);
    }

    // this._getFiels(appId, entryId, widgetId);
    let autoHeight = this._getStoreValue("autoHeight") || this.props.autoHeight;
    let limit = this._getStoreValue("datatablelimit") || this.props.pageSize;
    if (!this.props.mountAutoLoad) {
      this.setState({
        limit: limit,
        autoHeight: autoHeight,
      });

      return;
    }

    this.setState(
      {
        limit: limit,
        autoHeight: autoHeight,
      },
      () => {
        this.loadWidget();
      }
    );
  }

  onscrollTop = (event) => {
    // let element = this.element.current.querySelector('.art-sticky-scroll');
    // function isScrolledToButtom(element) {
    //   // 元素的scrollLeft属性是滚动条左边界到元素左边界的距离
    //   // 元素的clientWidth属性是元素的内部可视宽度
    //   // 元素的scrollWidth属性是元素的总内容宽度
    //   return element.scrollTop + element.clientHeight >= element.scrollHeight;
    // }
    // // let menus = this.element.current.querySelectorAll('.right-cell-menu')
    // if (isScrolledToButtom(event.target)) {
    //   console.log('滚动条到达了盒子的右边界！');
    //   // for (let index = 0; index < menus.length; index++) {
    //     event.target.classList.add('bottom');
    //   // }
    // } else {
    //   console.log('滚动条还没有到达盒子的右边界。');
    //   // for (let index = 0; index < menus.length; index++) {
    //     event.target.classList.remove('bottom');
    //   // }
    // }
  };

  onscroll = (event) => {
    let scrollLeft =
      this.element.current.querySelector(".art-sticky-scroll").scrollLeft;

    let element = this.element.current.querySelector(".art-sticky-scroll");
    function isScrolledToRight(element) {
      // 元素的scrollLeft属性是滚动条左边界到元素左边界的距离
      // 元素的clientWidth属性是元素的内部可视宽度
      // 元素的scrollWidth属性是元素的总内容宽度
      return element.scrollLeft + element.clientWidth >= element.scrollWidth;
    }

    function isScrolledToButtom(element) {
      // 元素的scrollLeft属性是滚动条左边界到元素左边界的距离
      // 元素的clientWidth属性是元素的内部可视宽度
      // 元素的scrollWidth属性是元素的总内容宽度
      return element.scrollTop + element.clientHeight >= element.scrollHeight;
    }

    let menus = this.element.current.querySelectorAll(".right-cell-menu");
    if (isScrolledToRight(element)) {
      // console.log('滚动条到达了盒子的右边界！');
      for (let index = 0; index < menus.length; index++) {
        menus[index].classList.add("endRight");
      }
    } else {
      // console.log('滚动条还没有到达盒子的右边界。');
      for (let index = 0; index < menus.length; index++) {
        menus[index].classList.remove("endRight");
      }
    }
    if (scrollLeft > 0) {
      // console.log('开始移动');
      this.element.current.classList.add("scroll-background");
    } else {
      // console.log('最左边');
      this.element.current.classList.remove("scroll-background");
    }
    let left = this.element.current.querySelectorAll(
      ".chart-data-border .blank"
    );
    for (let index = 0; index < left.length; index++) {
      const element = left[index];
      if (element) {
        let el = element.previousSibling;
        if (scrollLeft === 0) el.style.borderRight = "";
        else el.style.borderRight = "none";
      }
    }
    let headerleft = this.element.current.querySelectorAll(
      ".art-table-header-row .last"
    );
    for (let index = 0; index < headerleft.length; index++) {
      const element = headerleft[index];
      if (element) {
        let el = element.previousSibling;
        if (scrollLeft === 0) el.style.borderRight = "";
        else el.style.borderRight = "none";
      }
    }
  };

  componentWillUnMount = () => {
    // let atb = this.element.current.querySelector('.art-sticky-scroll');
    // if (atb) {
    //   atb.removeEventListener('scroll', this.onscroll)
    // }
  };

  loadWidget = (n, d, s) => {
    this.loadData(n, d, s);
    if (this.props.hasCount) {
      this.loadDataCount(n, d);
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.isDashFull !== this.isDashFull) {
      this.isDashFull = nextProps.isDashFull;
    }

    if (
      !this.props.multipleChoice &&
      this.state.level2Menu !== nextProps.level2Menu
    ) {
      this.selectDataId = [];
      this.setState(
        {
          ...nextProps,
          menu: this.toMenu(nextProps.menu),
          showFieldsMeta: this._getColSizeMap(),
        },
        () => {
          this.lastcolumnResize = [];
          this.columnSizeMap = null;
          //优化写法 减少数据加载的次数
          this.transformData();
          // this.loadData();
          // if (this.props.hasCount) {
          //   this.loadDataCount();
          // }
        }
      );
    } else {
      if (!isEqual(this.selectDataId, nextProps.selectDataId)) {
        if (nextProps.selectDataId) {
          this.selectDataId = Array.isArray(nextProps.selectDataId)
            ? [...nextProps.selectDataId]
            : [];
        }
        this.hasXScroll();
        this.setState(
          {
            // selectDataId: nextProps.selectDataId ? [...nextProps.selectDataId] : []
          },
          () => {
            this.hasXScroll();
          }
        );
      }
    }
  }

  _updateSort = (ddsort) => {
    //准备排序
    const sort = ddsort.map((data, index) => {
      let newData = {
        [data.code]: data.order === "desc" ? -1 : 1,
      };
      return newData;
    });
    this.setState(
      {
        sort,
        skip: 0,
      },
      () => {
        this.loadData();
      }
    );
  };

  doResize = () => { };

  _getColSizeMap = () => {
    let t = this._getColSizeMapKey();
    return BsyUtils.Store.get(t) || {};
  };
  _updateColSize = (val) => {
    const { columns } = this.state;
    let columnResize = {};
    let columnIndex = 0;
    for (let i = 0; i < columns.length; i++) {
      if (columns[i].widgetType == "subform") {
        let children = columns[i].children;
        for (let ichild = 0; ichild < children.length; ichild++) {
          columnResize[children[ichild].code] = val[columnIndex];
          columnIndex++;
        }
      } else {
        columnResize[columns[i].code] = val[columnIndex];
        columnIndex++;
      }
    }

    let i = this._getColSizeMapKey();
    BsyUtils.Store.set(i, columnResize);
  };

  //方便统一调用
  _getStoreKey = (name) => {
    const { appId, entryId, widgetId, authGroupId } = this.props;
    return BsyUtils.Store.getKey(name, {
      appId: appId,
      entryId: entryId,
      widgetId: widgetId,
      authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : "",
    });
  };
  //方便统一调用
  _updateStoreValue = (name, val) => {
    let i = this._getStoreKey(name);
    BsyUtils.Store.set(i, val);
  };

  //方便统一调用
  _getStoreValue = (name) => {
    let t = this._getStoreKey(name);
    return BsyUtils.Store.get(t);
  };

  _getColSizeMapKey = () => {
    const { appId, entryId, widgetId, StoregetKey, authGroupId } = this.props;
    return BsyUtils.Store.getKey(StoregetKey, {
      appId: appId,
      entryId: entryId,
      widgetId: widgetId,
      authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : "",
    });
  };

  _getSortsKey = () => {
    const { appId, entryId, widgetId, sortKey, authGroupId } = this.props;
    return BsyUtils.Store.getKey(sortKey, {
      appId: appId,
      entryId: entryId,
      widgetId: widgetId,
      authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : "",
    });
  };
  _updateSortsMap = (val) => {
    let i = this._getSortsKey();
    BsyUtils.Store.set(i, val);
  };
  _getSortsMap = () => {
    let t = this._getSortsKey();
    return BsyUtils.Store.get(t) || {};
  };

  _getShowFieldMap = () => {
    let t = this._getColSizeMapKey();
    return BsyUtils.Store.get(t) || {};
  };
  _updateShowField = (val) => {
    let i = this._getColSizeMapKey(),
      a = this._getColSizeMap();
    // a[t] = e,
    BsyUtils.Store.set(i, val);
  };
  _getShowFieldKey = (appId1, entryId1, widgetId1, authGroupId) => {
    return BsyUtils.Store.getKey("dashboardShowFields", {
      appId: appId1,
      entryId: entryId1,
      widgetId: widgetId1,
      authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : "",
    });
  };
  _getColumnSize = (a, b) => {
    // let c = _options;

    if (!this.columnSizeMap) {
      let d = {};
      BsyUtils.forEach(this.state.showFieldsMeta, function (a, b) {
        d[a] = b;
      });
      this.columnSizeMap = d;
    }
    let e = a.tag || a.name;
    a.subform && (e = [a.subform, e].join("."));
    // BsyUtils.isNumber(b) && (e = [e, b].join("#"));
    let f = this.columnSizeMap[e];
    if (f) return f;
    if (a && a.width) {
      return a.width < 35 ? 35 : a.width;
    }

    if (e === "_id") {
      //默认情况下 数据id  一行要能显示全部
      return 190;
    }
    if (e === "f_row_menu") {
      //默认情况下 数据id  一行要能显示全部
      return 200;
    }

    switch (a.type) {
      case "textarea":
      case "address":
      case "location":
        return 300;
      case "image":
      case "signature":
      case "upload":
        return 100;
      case "usergroup":
      case "deptgroup":
        return 250;
      case "combocheck":
      case "checkboxgroup":
        return BsyUtils.isNumber(b) ? 100 : 300;
      case "button": {
        return 100;
      }
      case "number": {
        if (a.tag === "f_row_order") {
          return 60;
        }
        return 150;
      }
      default:
        return 150;
    }
  };

  getColumnAlign = (header) => {
    if (header.tag === "f_row_order") {
      return "center";
    }

    const { styles } = this.props;

    switch (header.alignment) {
      case "h-left": {
        return "left";
      }
      case "h-right": {
        return "right";
      }
      case "h-center": {
        return "center";
      }
      default: {
        if (styles) {
          if (styles.fontSetting) {
            if (styles.fontSetting.textAlign) {
              return styles.fontSetting.textAlign;
            }
          }
        }

        return "";
      }
    }
  };

  getColumnLock = (index, header) => {
    // if (header.tag === 'f_row_order') {
    //   this.lockColunIndex++;
    //   return true;
    // }

    const { sticky_column, stickyDataMenu } = this.props;

    if (header.type === "menu") {
      if (stickyDataMenu) {
        return true;
      } else {
        return false;
      }
    }

    if (!sticky_column) return false;
    if (!sticky_column.enable) return false;
    if (!sticky_column.limit) return false;

    if (!header.subform) {
      if (this.lockColunIndex < sticky_column.limit) {
        this.lockColunIndex++;
        return true;
      }
    } else {
      if (this.locksubform === header.subform) {
        return true;
      }

      if (this.lockColunIndex < sticky_column.limit) {
        this.lockColunIndex++;
        this.locksubform = header.subform;
        return true;
      }
    }
    return false;
  };

  isShow = (tag) => {
    let show = false;
    this.fields.map((data, index) => {
      let ddtag = data.tag || data.name;
      if (show) return "";

      if (ddtag === tag) {
        show = true;
      }
      if (data.type === "subform") {
        data.items.map((subdata) => {
          let dstag = [ddtag, subdata.name].join(".");
          if (dstag === tag) {
            show = true;
          }
          return "";
        });
      }
      return "";
    });
    return show;
  };

  onMultiSelect = (e, id) => {
    // console.log("onMultiSelect", e, id);
    const { checkStatus, saveMultiPageData } = this.state;
    const { selectDataId } = this;
    const rowData = this.AllData.find((row) => row._id === id);
    if (checkStatus != "check") {
      this.props.selectSingleData(rowData);
      return;
    }

    let localselectDataId = [];

    if (id === "all") {
      this.ignoreDataId = [];
      if (e) {
        this.AllData.map((data) => {
          localselectDataId.push(data._id);
        });
      }
    } else {
      localselectDataId = [...selectDataId];
      if (e) {
        localselectDataId.push(id);
      } else {
        let i = localselectDataId.indexOf(id);
        localselectDataId.splice(i, 1);
      }
      const bak = [...localselectDataId];
      localselectDataId = [];

      this.AllData.map((data) => {
        if (bak.indexOf(data._id) > -1) {
          localselectDataId.push(data._id);
        }
      });
    }

    //处理左侧选项状态
    if (localselectDataId.length === 0) {
      this.AllData.map((data) => {
        if (this.checkRefMap[data._id])
          this.checkRefMap[data._id].setValue(false);
      });
    } else {
      for (let i = 0; i < this.ignoreDataId.length; i++) {
        let pos = localselectDataId.indexOf(this.ignoreDataId[i]);
        if (pos > -1) localselectDataId.splice(pos, 1);
      }
      for (let i = 0; i < localselectDataId.length; i++) {
        if (this.checkRefMap[localselectDataId[i]])
          this.checkRefMap[localselectDataId[i]].setValue(true);
      }

      if (id !== "all") {
        if (!e) {
          if (this.checkRefMap[id]) this.checkRefMap[id].setValue(e);
        }
      }
    }
    // console.log('localselectDataId', CircularJSON.stringify(localselectDataId));
    let tmpid = []; //重新排序,多选择的时候 排序不正确的BUG
    this.AllData.map((data) => {
      if (localselectDataId.indexOf(data._id) > -1) {
        tmpid.push(data._id);
      }
    });
    // console.log('tmpid', CircularJSON.stringify(tmpid))
    localselectDataId = [...tmpid];

    this.AllCheckContext &&
      this.AllCheckContext.setValue(
        localselectDataId.length === this.AllData.length
      );

    this.onCheckRow(localselectDataId, rowData);
    this.selectDataId = [...localselectDataId];

    if (saveMultiPageData) {
      if (id === "all") {
        this.AllData.map((it) => {
          this.opSelectData(e, it._id);
          return it._id;
        });
      } else {
        this.opSelectData(e, id);
      }
      this.selectDataId = this.selecteData.map((it) => it._id);
      console.log(
        "selectDataId",
        this.selecteData.map((it) => it._id)
      );
    }
    this.Turnpage && this.Turnpage.setSelectData(this.selectDataId);
  };

  // 处理翻页的数据选择
  opSelectData = (check, id) => {
    if (check) {
      let rowData = this.AllData.filter((it) => {
        return it._id === id;
      });
      this.selecteData = this.selecteData.concat(rowData);
    } else {
      let data = this.selecteData.filter((it) => {
        if (!check) {
          return it._id !== id;
        }
        return true;
      });
      this.selecteData = data;
    }
  };

  onCheckRow = (data, rowData) => {
    if (this.props.onCheckRow) {
      this.props.onCheckRow(data, rowData);
    }
  };

  getSelectDataId = () => {
    const { selectDataId } = this;
    return selectDataId;
  };

  getAllDataId = () => {
    let datas = this.AllData.map((data) => data._id);
    return datas;
  };

  transformColumns = (args, subform, widgetName) => {
    const { level2Menu, isCheckAll, checkStatus } = this.state;
    const { multipleChoice, widgetId } = this.props;

    let headers = [];

    if (!subform) {
      if (level2Menu || multipleChoice) {
        //自定义多选择
        const node = {
          code: "isCheck",
          name: (
            <>
              {checkStatus == "check" ? (
                <BsyCheckBox
                  value={isCheckAll}
                  onChange={(e) => {
                    this.onMultiSelect(e, "all");
                  }}
                />
              ) : (
                ""
              )}
            </>
          ),
          width: 50,
          lock: true,
          features: { sortable: false, autoRowSpan: this.autoRowSpan },
          align: "center",
          render: (value, record, rowIndex) => {
            //处理自定义单元格元素， 'image', 'upload', 'menu', 'textarea'

            if (this.props.onCheckHook) {
              let res = this.props.onCheckHook(record);
              if (res === true) {
                return (
                  <>
                    <div className="bsy-td-background"></div>
                    <BsyCheckBox
                      getContext={(context) => {
                        this.checkRefMap[record._id] = context;
                      }}
                      value={
                        this.selectDataId.indexOf(record._id) > -1
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        this.onMultiSelect(e, record._id);
                      }}
                    />
                    {this.props.quickEdit ? (
                      <BsySLoading
                        style={{ display: "none" }}
                        customCls={"small"}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              }

              this.ignoreDataId.push(record._id);
              if (res === false) {
                return "";
              }
              return res;
            } else {
              return (
                <>
                  {checkStatus == "check" ? (
                    <>
                      <div className="bsy-td-background"></div>
                      <BsyCheckBox
                        getContext={(context) => {
                          this.checkRefMap[record._id] = context;
                        }}
                        value={
                          this.selectDataId &&
                            this.selectDataId.indexOf(record._id) > -1
                            ? true
                            : false
                        }
                        onChange={(e) => {
                          this.onMultiSelect(e, record._id);
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <div className="bsy-td-background"></div>
                      <BsyRadioBox
                        getContext={(context) => {
                          this.checkRefMap[record._id] = context;
                        }}
                        value={this.selectDataId == record._id ? true : false}
                        onChange={(e) => {
                          this.onMultiSelect(e, record._id);
                        }}
                      ></BsyRadioBox>
                    </>
                  )}
                  {this.props.quickEdit ? (
                    <BsySLoading
                      style={{ display: "none" }}
                      customCls={"small"}
                    />
                  ) : (
                    ""
                  )}
                </>
              );
            }
          },
        };
        headers.push(node);
      }
    }

    args.map((data, index) => {
      let tmpdata = { ...data };
      let tag = tmpdata.tag || tmpdata.name;
      if (subform) {
        tmpdata.subform = subform;
        tmpdata.subformWidgetName = widgetName;
        tag = [tmpdata.subform, tag].join(".");
      }
      if (subform) {
        if (data.type === "dataload") {
          return "";
        }
      }

      if (data.type !== "menu" && data.tag !== "f_row_order") {
        if (!this.isShow(tag)) {
          return "";
        }
      }

      if (tmpdata.type === "chargers") {
        let lock = this.getColumnLock(index, data);
        const node = {
          code: tag + "currentnode",
          name: React.language("flow.node.current"),
          colorText: data.colorText ? [...data.colorText] : null,
          widgetType: tmpdata.type,
          customCls: tmpdata.customCls,
          width: this._getColumnSize(tmpdata),
          features: this.getSort(tmpdata),
          orgField: { ...tmpdata },
          align: "left",
          lock: lock,
          render: (value, record, rowIndex) => {
            //处理自定义单元格元素， 'image', 'upload', 'menu', 'textarea'
            return this.renderCustomCell(
              value,
              record,
              rowIndex,
              tmpdata,
              0,
              lock
            );
          },
        };
        lock = this.getColumnLock(index, data);
        const charger = {
          code: tag + "currentcharger",
          name: React.language("flow.charger.current"),
          colorText: data.colorText ? [...data.colorText] : null,
          widgetType: "usergroup", //tmpdata.type,
          customCls: tmpdata.customCls,
          width: this._getColumnSize(tmpdata),
          features: this.getSort(tmpdata),
          orgField: { ...tmpdata },
          align: "left",
          lock: lock,
          render: (value, record, rowIndex) => {
            //处理自定义单元格元素， 'image', 'upload', 'menu', 'textarea'
            return this.renderCustomCell(
              value,
              record,
              rowIndex,
              tmpdata,
              0,
              lock
            );
          },
        };
        headers.push(node);
        headers.push(charger);
      } else if (tmpdata.type === "subform") {
        if (!data.detailOnly) {
          const node = {
            code: tag,
            name: tmpdata.text || tmpdata.title,
            widgetName: tmpdata.name,
            widgetType: tmpdata.type,
            width: this._getColumnSize(tmpdata),
            customCls: tmpdata.customCls,
            align: "center",
            features: this.getSort(tmpdata),
            // lock: this.getColumnLock(index, data),
            // children: this.transformColumns(tmpdata.items, tag),
            children: this.transformColumns(tmpdata.items, tag, tmpdata.name),
          };

          this.subofrmMap.push({ ...tmpdata });

          headers.push(node);
        }
      } else if (data.isMenu) {
        let colWidth = this._getColumnSize(tmpdata); // 200 像素的宽度 根据文字的实际占宽来显示
        if (colWidth < 80) {
          colWidth = 80;
        }
        let lock = this.getColumnLock(index, data);
        const node = {
          code: tag,
          name: React.language("order.operation"),
          widgetType: tmpdata.type,
          customCls: tmpdata.customCls,
          width: colWidth,
          minwidth: 80,
          features: this.getSort(tmpdata),
          lock: lock,
          align: "center",
          render: (value, record, rowIndex) => {
            //处理自定义单元格元素， 'image', 'upload', 'menu', 'textarea'
            return this.renderCustomCell(
              value,
              record,
              rowIndex,
              tmpdata,
              this.lastcolumnResize.length
                ? this.lastcolumnResize[this.lastcolumnResize.length - 2]
                : colWidth,
              lock
            );
          },
        };
        headers.push(node);
      } else {
        if (!tmpdata.detailOnly) {
          // let hasRender = false
          // if (['image', 'upload', 'signature', 'menu', 'textarea', 'text',
          //   'checkboxgroup', 'combocheck', 'array', 'radiogroup', 'combo', 'number', 'formula', "user", "usergroup", "dept", "deptgroup"
          // ].indexOf(data.type) > -1) {
          //   hasRender = true;
          // }

          let lock = this.getColumnLock(index, { subform: subform, ...data });
          let align = this.getColumnAlign(tmpdata);
          tmpdata.align = align;
          const node = {
            code: tag,
            alignment: tmpdata.alignment,
            name: tmpdata.text || tmpdata.title,
            widgetType: data.type,
            customCls: tmpdata.customCls,
            colorText: data.colorText ? [...data.colorText] : null,
            orgField: { ...tmpdata },
            width: this._getColumnSize(tmpdata),
            minwidth: data.type == "button" ? 100 : 50,
            align: align,
            features: this.getSort(tmpdata),
            lock: lock,
            render: (value, record, rowIndex) => {
              //处理自定义单元格元素， 'image', 'upload', 'menu', 'textarea'
              return this.renderCustomCell(
                value,
                record,
                rowIndex,
                tmpdata,
                0,
                lock
              );
            },
          };
          headers.push(node);
        }
      }
      return data;
    });
    if (!subform) {
      //用于处理占位，解决拖动表格的时候，影响其他列的问题

      // if (widgetId.indexOf('form-visit') > -1) {
      //   //普通表单
      //   headers.push({
      //     code: 'blank',
      //     width: 'auto'
      //   })
      // } else {
      //   headers.push({
      //     code: 'blank',
      //     lock: true,
      //     width: 'auto'
      //   })
      // }
      headers.push({
        code: "blank",
        lock: true,
        width: 0,
        render: () => {
          return <div className="bsy-td-background"></div>;
        },
      });
    }

    return [...headers];
  };

  BBY_menuEvent = (menuId, menu, rowdata, action, cb) => {
    let _this = this;
    let _options = this.props;
    if (!_this.menuStatus) {
      _this.menuStatus = {};
    }
    if (_this.menuStatus[menuId]) {
      return;
    }
    let extendSet = menu.extendSet;
    if (BsyUtils.isObjectEmpty(extendSet)) {
      extendSet = {};
      extendSet.funMode = menu.type;
      extendSet.libs = menu.libs;
      extendSet.module = menu.module;
    } else {
      extendSet.funMode = menu.type;
    }

    let t1 = null;
    switch (extendSet.funMode) {
      case "event":
      case "module":
      case "datahelp": {
        if (BsyUtils.isObjectEmpty(extendSet.module)) {
          extendSet.funMode = menu.type;
          extendSet.libs = menu.libs;
          extendSet.module = menu.module;
        }

        BsyMaskLayer({
          customCls: "sloading",
          onContentCreate: (ref) => {
            t1 = ref;
            return (
              <div>
                <BsySLoading />{" "}
              </div>
            );
          },
        });
        break;
      }

      case "popupform":
      case "popupreport":
        BsyMaskLayer({
          customCls: "sloading",
          onContentCreate: (ref) => {
            t1 = ref;
            return (
              <div>
                <BsySLoading />{" "}
              </div>
            );
          },
        });
        break;
      default: {
      }
    }
    _this.menuStatus[menuId] = !0;
    window.FX.Utils.dataAjax(
      {
        url: "/data/reporttablemenu",
        data: {
          appId: _options.appId,
          entryId: _options.entryId,
          formId: _options.forms[0], //数据来源的id   如果是跨 应用的 按照 @的类型来  53cf7491f2cda6ede7cd7c57@5edf010e013952f2fe30b139
          pupupFormId: menu.formId, //数据来源的id   如果是跨 应用的 按照 @的类型来  53cf7491f2cda6ede7cd7c57@5edf010e013952f2fe30b139
          widgetId: _options.widgetId, //控件id
          dataId: [rowdata._id], //数据id 不管多选还是单选 都是数组
          data: rowdata, //数据id 不管多选还是单选 都是数组
          header: _this.props.fields, //数据id 不管多选还是单选 都是数组
          filter: this.getFilterData(), //筛选条件的值,
          menuId: menu.menuId, //菜单id,
          arg: menu.arg, //菜单id,
          datahelpids: extendSet.datahelpids, //数据助手id,
          libs: extendSet.libs, //功能操作相关的参数,
          value: menu.value, //功能操作相关的参数,
          type: extendSet.funMode || menu.type, //菜单id,
          action: action, //菜单类型 0单条 1批量
          batch: menu.selectAll, //是否全选 1全选 0无全选 批量的情况才有可能全选
          popupFormPath: _this.popupFormPath.concat({
            appId: _this.props.appId,
            entryId: _this.props.entryId,
            formId: _this.props.forms[0],
            widgetId: _this.props.widgetId,
            AppMobileMenu: _this.props.AppMobileMenu,
            menuId: menu.menuId,
            menuType: "datamenu",
          }),
        },
      },
      function (t) {
        t.dataId = rowdata._id;
        cb(t, menu);
        _this.menuStatus[menuId] = !1;
        if (t1) {
          t1.close();
          t1 = null;
        }
      },
      function (t) {
        _this.menuStatus[menuId] = !1;
        let c = CircularJSON.parse(t.responseText) || {};
        cb(c, menu);
        if (t1) {
          t1.close();
          t1 = null;
        }
      },
      function () {
        _this.menuStatus[menuId] = !1;
        if (t1) {
          t1.close();
          t1 = null;
        }
      }
    );
  };

  moreOperate = (record, menu, menuEls, event) => {
    let menus = [];
    for (let i = menuEls.length; i < menu.length; i++) {
      let b1 = menu[i];

      menus.push({
        text: menu[i].mode === "text" ? menu[i].name : "",
        icon:
          menu[i].mode !== "text" ? "icon-bsy-reportmenu-" + menu[i].icon : "",
        colorType:
          !record.dataPerms ||
            !record.dataPerms.menu ||
            !record.dataPerms.menu[b1.menuId]
            ? "no-drop"
            : "",
        color: menu[i].color,
        tipText: menu[i].tip,
        click: () => {
          if (
            !record.dataPerms ||
            !record.dataPerms.menu ||
            !record.dataPerms.menu[b1.menuId]
          ) {
            return;
          }
          this.dataMenuOperate(menu[i], record);
        },
        onMouseEnter: (event) => {
          if (menu[i].tip) {
            window.FX.UI.showPopover({
              position: "bottomLeft",
              anchor: window.$(event.target),
              content: window.$("<span />").text(menu[i].tip),
              type: "dark",
            });
          }
        },
        onMouseLeave: (event) => {
          if (menu[i].tip && window.FX && window.FX.UI) {
            window.FX.UI.closePopover();
          }
        },
      });
    }

    BsyAlertMenu({
      item: menus,
      width: 100,
      target: event.target,
      customCls: "more-menu",
      theme: this.props.theme,
    });
  };

  getPupupDashContext = (content) => {
    this.pupupDashContext = content;
  };

  onResetFilter = () => {
    if (this.pupupDashContext && this.pupupDashContext.ResetFilter)
      this.pupupDashContext.ResetFilter();
  };

  onResetRel = (t) => {
    if (this.pupupDashContext && this.pupupDashContext.setRel)
      this.pupupDashContext.setRel(t);
  };

  dataMenuOperate = (menu, ddrow, action, event) => {
    let that = this;
    const { onRowMenuEvent } = this.props;
    let rowdata = { ...that.AllData[ddrow.dataIndex] };
    if (typeof onRowMenuEvent === "function")
      onRowMenuEvent(menu, rowdata, that.reftype, event);
    return;
  };

  renderDataMenu = (record, menuColWidth) => {
    const { menu } = this.state;
    if (!this.props.menu.enable) {
      return "";
    }

    // this.minMenuColWidth = 200;
    //根据 menuColWidth的值动态调整可显示的菜单数量
    let n = menu.length;
    let curWidth = 0;
    let menuEls = [];
    for (let index = 0; index < n; index++) {
      let b1 = menu[index];

      curWidth += b1.width;
      if (this.props.menu.style === "more") {
        if (curWidth > menuColWidth - 48) {
          // console.log(index,curWidth   , menuColWidth  - 48)
          break;
        }
      }

      if (
        !record.dataPerms ||
        !record.dataPerms.menu ||
        !record.dataPerms.menu[b1.menuId]
      ) {
        //无权限的情况
        if (b1.mode === "text") {
          menuEls.push(
            <div
              key={"1"}
              className={"item"}
              style={{ color: "#aaa", cursor: "no-drop" }}
            >
              {b1.name}
            </div>
          );
        } else {
          menuEls.push(
            <div key={"2"} className={"item"}>
              <i
                className={" icon-bsy-reportmenu-" + b1.icon + ""}
                style={{ color: "#aaa", cursor: "no-drop" }}
              ></i>
            </div>
          );
        }
      } else {
        if (b1.mode === "text") {
          menuEls.push(
            <div
              key={"3"}
              onClick={(e) => {
                e.stopPropagation();
                this.dataMenuOperate(b1, record, 0, e);
              }}
              className={"item"}
              style={{ color: b1.color, cursor: "pointer" }}
              onMouseEnter={(event) => {
                if (b1.tip) {
                  window.FX.UI.showPopover({
                    position: "bottomLeft",
                    anchor: window.$(event.target),
                    content: window.$("<span />").text(b1.tip),
                    type: "dark",
                  });
                }
              }}
              onMouseLeave={(event) => {
                if (b1.tip && window.FX && window.FX.UI) {
                  window.FX.UI.closePopover();
                }
              }}
            >
              {b1.name}
            </div>
          );
        } else {
          menuEls.push(
            <div
              key={"4"}
              className={"item"}
              onMouseEnter={(event) => {
                if (b1.tip) {
                  window.FX.UI.showPopover({
                    position: "bottomLeft",
                    anchor: window.$(event.target),
                    content: window.$("<span />").text(b1.tip),
                    type: "dark",
                  });
                }
              }}
              onMouseLeave={(event) => {
                if (b1.tip && window.FX && window.FX.UI) {
                  window.FX.UI.closePopover();
                }
              }}
            >
              <i
                onClick={(e) => {
                  e.stopPropagation();
                  this.dataMenuOperate(b1, record, 0, e);
                }}
                className={"  icon-bsy-reportmenu-" + b1.icon + ""}
                style={{ color: b1.color, cursor: "pointer" }}
              ></i>
            </div>
          );
        }
      }
    }

    return (
      <>
        <div className="bsy-td-background"></div>
        <div
          className={
            "op-menu " + (this.props.menu.style === "more" ? "more" : "row")
          }
        >
          {menuEls.map((data, index) => {
            return data;
          })}
          {this.props.menu.style === "more" &&
            menu.length !== menuEls.length && (
              <div className="more-btn">
                <i
                  className={"icon-bsy-icongengduo1"}
                  style={{ color: "#666666" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.moreOperate(record, menu, menuEls, e);
                  }}
                ></i>{" "}
              </div>
            )}
        </div>
      </>
    );
  };

  cellElements = (value, widget, record) => {
    const {
      appId,
      autoHeight,
      forms,
      is_dock_form,
      formItems,
      authGroupId,
      optAuth,
    } = this.state;

    switch (widget.type) {
      case "radiogroup":
      case "combo": {
        if (widget.colorEnable) {
          return <BsyTagList header={widget} data={[value]} />;
          // return React.createElement('div', { title: value, dangerouslySetInnerHTML: { __html: z.innerHTML } })
        }

        return (
          <div title={value} className={"table-text"}>
            {this.highlighterText(value, widget)}
          </div>
        );
      }
      case "checkboxgroup":
      case "combocheck":
      case "array": {
        if (widget.colorEnable) {
          if (Array.isArray(value)) {
            return <BsyTagList header={widget} data={value} />;
          }
        }
        let title = "";
        if (Array.isArray(value)) {
          title = value.join(",");
        }

        return (
          <div title={title} className={"table-text"}>
            {this.highlighterText(title, widget)}
          </div>
        );
      }

      case "textarea": {
        if (autoHeight === "low") {
          return (
            <div className={"pre"} title={value}>
              {this.highlighterText(value, widget)}
            </div>
          );
        }
        return (
          <pre className={"pre"} title={value}>
            {this.highlighterText(value, widget)}
          </pre>
        ); //React.createElement('pre', null, value)
      }

      case "datetime": {
        let time = "";
        if (value) {
          time = BsyUtils.date2Str(
            dayjsUtils.timeToTZ(value),
            widget.format || "yyyy-MM-dd"
          );
        }

        return (
          <div title={time} className={"table-text"}>
            {time}
          </div>
        );
      }
      case "sn":
      case "text": {
        if (widget.regex === "imageurl") {
          let patt1 = new RegExp(BsyConfig().CONST.TEXT_TYPE_REGEXP.URL);
          if (patt1.test(value)) {
            return (
              <BsyThumbList
                widget={widget}
                files={[{ imageUrl: value }]}
                hasTooltip={false}
                hasPreview={
                  !widget.hasOwnProperty("preview") ? true : widget.preview
                }
                noDownload={true}
                appId={appId}
                dataId={record._id}
                formId={forms[0]}
                previewHeight={240}
                previewWidth={240}
              />
            );
          }

          return this.renderText(value, widget);
        }

        if (widget.regex === "qrcode") {
          return (
            <div
              className="text-qrcode"
              onClick={(e) => {
                e.stopPropagation();
                let cansv = e.currentTarget.querySelector("canvas");
                if (cansv) {
                  this.previewCanves(cansv);
                }
              }}
            >
              {value && (
                <QRCode
                  value={value} //value参数为生成二维码的链接
                  size={256} //二维码的宽高尺寸
                  fgColor={"#333"} //二维码的颜色
                />
              )}
            </div>
          );
        }
        if (widget.regex === "barcode") {
          return (
            <div
              className="text-barcode"
              onClick={(e) => {
                e.stopPropagation();
                if (value) {
                  let cansv = e.currentTarget.querySelector("canvas");
                  if (cansv) {
                    this.previewCanves(cansv, widget);
                  }
                }
              }}
            >
              {value && (
                <Barcode
                  renderer={"canvas"}
                  value={value}
                  displayValue={true}
                  height={130}
                />
              )}
            </div>
          );
        }
        return this.renderText(value, widget);
      }
      case "formula":
      case "number": {
        if (!BsyUtils.isObjectEmpty(value) && !value.hasOwnProperty("value")) {
          let value1 = {
            value: "",
            text: "",
          };
          if (["assist_protime", "assist_outtime"].includes(widget.name)) {
            value1 = BsyUtils.numberFormatTime(value, widget);
          } else {
            value1 = BsyUtils.numberFormatValue(value, widget);
          }
          value = value1;
        }
        if (widget.isOrderCol) {
          return (
            <div className="row-order">
              {!BsyUtils.isObjectEmpty(value) ? value.text : ""}
            </div>
          );
        }

        let text = !BsyUtils.isObjectEmpty(value) ? value.text : "";

        const afterSuffixVal = getAfterSuffix(widget.afterSuffix)
        let textVal = this.highlighterText(text, widget);
        if (afterSuffixVal && textVal && !textVal.includes("%")) {
          textVal = <span style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>{textVal} <span style={{ color: "#999" }}>{afterSuffixVal}</span></span>;
        }
        return (
          <div
            title={text}
            className={"table-text"}
          >
            {textVal}
          </div>
        );
      }
      case "user": {
        let dd = [];

        try {
          if (BsyUtils.isString(value)) {
            if (window.userSelectMap && window.userSelectMap[value]) {
              dd = window.userSelectMap[value];
            } else {
              dd = CircularJSON.parse(value);
            }
          } else dd = value;
        } catch (error) {
          dd = null;
        }

        return (
          <div className={"table-text"}>
            <BsyUserThumbList
              list={dd ? [dd] : []}
              appId={appId}
              is_dock_form={is_dock_form}
            />
          </div>
        );
      }
      case "usergroup": {
        let dd = [];

        try {
          if (BsyUtils.isArray(value)) {
            dd = value;
          } else dd = CircularJSON.parse(value);
        } catch (error) {
          dd = [];
        }

        return (
          <div className={"table-text"}>
            <BsyUserThumbList
              list={dd}
              appId={appId}
              is_dock_form={is_dock_form}
            />
          </div>
        );
      }
      case "dept": {
        let dd = [];
        try {
          if (BsyUtils.isString(value)) {
            if (window.deptSelectMap && window.deptSelectMap[value]) {
              dd = window.deptSelectMap[value];
            } else {
              dd = CircularJSON.parse(value);
            }
          } else dd = value;
        } catch (error) {
          dd = null;
        }

        return (
          <div className={"table-text"}>
            <BsyDeptThumbList
              list={dd ? [dd] : []}
              appId={appId}
              is_dock_form={is_dock_form}
            />
          </div>
        );
      }
      case "deptgroup": {
        let dd = [];

        try {
          if (BsyUtils.isArray(value)) {
            dd = value;
          } else dd = CircularJSON.parse(value);
        } catch (error) {
          dd = [];
        }

        return (
          <div className={"table-text"}>
            <BsyDeptThumbList
              list={dd}
              appId={appId}
              is_dock_form={is_dock_form}
            />
          </div>
        );
      }
      case "location":
      case "address": {
        let dd = {};
        try {
          // console.log('--location address--', BsyUtils.isString(value), value);
          if (BsyUtils.isString(value)) {
            dd = CircularJSON.parse(value);
          } else dd = value;
        } catch (error) {
          dd = null;
        }

        value = BsyUtils.address2Str(dd, widget.format || "pcda", "-") || "";
        // console.log('--location address--', dd, value);
        return (
          <div title={value} className={"table-text"}>
            {this.highlighterText(value, widget)}
          </div>
        );
      }

      case "upload": {
        let dd = [];
        let online_edit = false;
        let online_edit_record = false;
        let is_file_down = false;
        let check_image_exif = false;
        let enable = false;
        let optAuth1 = optAuth;
        if (!optAuth) {
          optAuth1 = record.optAuth;
        }
        // eslint-disable-next-line array-callback-return
        formItems.map((res) => {
          if (res.widget.type === "subform") {
            // eslint-disable-next-line array-callback-return
            res.widget.items &&
              res.widget.items.map((res1) => {
                if (res1.widget.widgetName === widget.name) {
                  online_edit = res1.widget.online_edit;
                  online_edit_record = res1.widget.online_edit_record;
                  is_file_down = res1.widget.is_file_down;
                  enable = res1.widget.enable;
                  check_image_exif = res1.widget.check_image_exif;
                }
              });
          } else {
            if (res.widget.widgetName === widget.name) {
              online_edit = res.widget.online_edit;
              online_edit_record = res.widget.online_edit_record;
              is_file_down = res.widget.is_file_down;
              enable = res.widget.enable;
              check_image_exif = res.widget.check_image_exif;
            }
          }
        });
        if (formItems.length <= 0) {
          check_image_exif = widget.check_image_exif;
        }
        if (optAuth1) {
          if (widget.subform) {
            const sAuth = optAuth1[widget.subformWidgetName];
            const auth = optAuth1[widget.subformWidgetName + "." + widget.name];
            if (auth) {
              online_edit = auth.online_edit;
              online_edit_record = auth.online_edit_record;
              is_file_down = auth.is_file_down;
              enable = auth.enable && sAuth.subform_edit;
            }
          } else {
            const auth = optAuth1[widget.name];
            if (auth) {
              online_edit = auth.online_edit;
              online_edit_record = auth.online_edit_record;
              is_file_down = auth.is_file_down;
              enable = auth.enable;
            }
          }
        }
        if (authGroupId === null && this.props.origin !== "report") {
          online_edit = true;
          online_edit_record = true;
          is_file_down = true;
          enable = true;
        }
        try {
          if (BsyUtils.isString(value)) {
            dd = CircularJSON.parse(value);
          } else dd = value;
        } catch (error) {
          dd = [];
        }

        return (
          <BsyFileThumbList
            widget={widget}
            files={dd}
            appId={appId}
            check_image_exif={check_image_exif}
            online_edit={online_edit && enable}
            online_edit_record={online_edit_record}
            is_file_down={is_file_down}
            dataId={record._id}
            rowData={record}
            authGroupId={authGroupId}
            formId={forms[0]}
            formMode={false}
          />
        );
      }

      case "image": {
        let dd = [];
        let is_file_down = false;
        let check_image_exif = false;
        let optAuth1 = optAuth;
        if (!optAuth) {
          optAuth1 = record.optAuth;
        }
        // eslint-disable-next-line array-callback-return
        formItems.map((res) => {
          if (res.widget.type === "subform") {
            // eslint-disable-next-line array-callback-return
            res.widget.items &&
              res.widget.items.map((res1) => {
                if (res1.widget.widgetName === widget.name) {
                  is_file_down = res1.widget.is_file_down;
                  check_image_exif = res1.widget.check_image_exif;
                }
              });
          } else {
            if (res.widget.widgetName === widget.name) {
              is_file_down = res.widget.is_file_down;
              check_image_exif = res.widget.check_image_exif;
            }
          }
        });
        if (formItems.length <= 0) {
          check_image_exif = widget.check_image_exif;
        }
        if (optAuth1) {
          if (widget.subform) {
            const auth = optAuth1[widget.subformWidgetName + "." + widget.name];
            if (auth) {
              is_file_down = auth.is_file_down;
            }
          } else {
            const auth = optAuth1[widget.name];
            if (auth) {
              is_file_down = auth.is_file_down;
            }
          }
        }
        if (authGroupId === null && this.props.origin !== "report") {
          is_file_down = true;
        }
        try {
          if (BsyUtils.isString(value)) {
            dd = CircularJSON.parse(value);
          } else dd = value;
        } catch (error) {
          dd = [];
        }

        return (
          <BsyThumbList
            widget={widget}
            files={dd}
            appId={appId}
            hasPreview={
              !widget.hasOwnProperty("preview") ? true : widget.preview
            }
            is_file_down={is_file_down}
            check_image_exif={check_image_exif}
            dataId={record._id}
            rowData={record}
            authGroupId={authGroupId}
            formId={forms[0]}
            formMode={false}
          />
        );
      }
      case "signature": {
        let dd = [];
        try {
          if (BsyUtils.isString(value)) {
            dd = CircularJSON.parse(value);
          } else dd = value;
        } catch (error) {
          dd = [];
        }
        let hasPreview = true;
        let hasTooltip = false;
        if (widget.type === "upload") {
          hasPreview = false;
          hasTooltip = true;
        } else {
          hasPreview = widget.preview === undefined ? !0 : widget.preview;
        }

        return (
          <BsyThumbList
            widget={widget}
            hasTooltip={hasTooltip}
            appId={appId}
            hasPreview={
              !widget.hasOwnProperty("preview") ? true : widget.preview
            }
            dataId={record._id}
            formId={forms[0]}
            previewHeight={widget.previewHeight || 450}
            previewWidth={widget.previewWidth || 450}
            files={dd}
          />
        );
      }

      default: {
        return (
          <div title={value} className={"table-text"}>
            {this.highlighterText(value, widget)}
          </div>
        );
      }
    }
  };

  getWidgetName = (widget) => {
    let name = widget.name || widget.widgetName;
    if (widget.subform) {
      let subform = widget.subform;
      if (widget.subform.indexOf("f_") > -1) {
        subform = this.widgetMap[widget.subform].name;
      }

      return [subform, name].join(".");
    }
    return name;
  };

  getOptAuth = (rowOptAuth, widgetName) => {
    if (widgetName === "f_row_order") {
      return false;
    }

    if (this.props.type === "data_table") {
      if (BsyUtils.isSubformWidget(widgetName)) {
        let d = widgetName.split(".");
        if (this.widgetMap[d[0]])
          widgetName = this.widgetMap[d[0]].name + "." + d[1];
      } else {
        if (this.widgetMap[widgetName])
          widgetName = this.widgetMap[widgetName].name;
      }
    }
    //验证字段可编辑权限
    if (rowOptAuth && rowOptAuth.hasOwnProperty(widgetName)) {
      if (BsyUtils.isSubformWidget(widgetName)) {
        let d = widgetName.split(".");
        if (!rowOptAuth[d[0]].subform_edit) {
          return false;
        }
      }
      if (!rowOptAuth[widgetName].enable) {
        return false;
      }
      // if (!rowOptAuth[widgetName].visible) {
      //   return false;
      // }
    }
    return true;
  };

  renderCellText = (value, widget, rowData) => {
    const { quickEdit, optAuth, authGroupId } = this.state;
    let textElements = this.cellElements(value, widget, rowData);
    let widgetName = this.getWidgetName(widget) || widget.tag;
    //['assist_protime', 'assist_outtime'].includes(widget.name)

    if (widgetName == "f_row_order") {
      return (
        <>
          <div className="bsy-td-background"></div>
          <div className="table-text"> {textElements} </div>
        </>
      );
    }

    if (
      [
        "creator",
        "createTime",
        "updateTime",
        "_id",
        "label",
        "assist_protime",
        "assist_outtime",
      ].includes(widgetName)
    ) {
      return (
        <>
          <div className="bsy-td-background"></div>
          <div className="table-text"> {textElements} </div>
        </>
      );
    }

    if (
      widgetName.indexOf("assist_protime") > -1 ||
      widgetName.indexOf("assist_outtime") > -1 ||
      widgetName.indexOf("assist_charger") > -1 ||
      widgetName.indexOf("assist_prostatus") > -1 ||
      widgetName.indexOf("assist_outtime") > -1
    ) {
      return (
        <>
          <div className="bsy-td-background"></div>
          <div className="bsy-edit-cell"> {textElements} </div>
        </>
      );
    }

    //权限组，无编辑权限

    let hasEditBtn =
      this.props.ignoreOptAuth ||
      (rowData.dataPerms
        ? rowData.dataPerms.update || rowData.dataPerms.flow_update
        : this.props.itemEditable);

    if (!hasEditBtn) {
      return (
        <>
          <div className="bsy-td-background"></div>
          <div className="bsy-edit-cell"> {textElements} </div>
        </>
      );
    }

    //验证字段可编辑权限
    if (authGroupId === 0) {
      let rowOptAuth = rowData.optAuth;
      if (!this.getOptAuth(rowOptAuth, widgetName)) {
        return (
          <>
            <div className="bsy-td-background"></div>
            <div className="bsy-edit-cell"> {textElements} </div>
          </>
        );
      }
    } else {
      let rowOptAuth = rowData.optAuth || optAuth;

      if (!this.getOptAuth(rowOptAuth, widgetName)) {
        return (
          <>
            <div className="bsy-td-background"></div>
            <div className="bsy-edit-cell"> {textElements} </div>
          </>
        );
      }
    }

    //没有未打开可编辑权限
    if (!quickEdit) {
      return (
        <>
          <div className="bsy-td-background"></div>
          <div className="bsy-edit-cell"> {textElements} </div>
        </>
      );
    }

    //非数据管理，不支持流水号修改
    if (!this.props.ignoreAuth && widget.type === "sn") {
      return (
        <>
          <div className="bsy-td-background"></div>
          <div className="bsy-edit-cell"> {textElements} </div>
        </>
      );
    }

    //序号，不可编辑
    if (widget.tag === "f_row_order") {
      return (
        <>
          <div className="bsy-td-background"></div>
          <div className="bsy-edit-cell"> {textElements} </div>
        </>
      );
    }

    if (widget.subform) {
      //子表单完全没有数据的情况下，需要处理为不可编辑权限
      if (!rowData.hasOwnProperty(widget.subform + "-row-index")) {
        return (
          <>
            <div className="bsy-td-background"></div>
            <div className="bsy-edit-cell"> {textElements} </div>
          </>
        );
      }
    }
    return this.renderEditCell(widget, rowData, value, textElements);
  };

  renderEditCell = (widget, rowData, value, textElements) => {
    const { quickEdit } = this.state;
    let ref = React.createRef();
    return (
      <>
        {quickEdit ? (
          <>
            <div className="bsy-td-background"></div>
            <div className="bsy-edit-cell" ref={ref}>
              <div
                className="content-edit"
                style={{
                  textAlign: widget.hasOwnProperty("align") ? widget.align : "",
                }}
                tabIndex={"-1"}
                onClick={(e) => {
                  e.stopPropagation();
                  //点击其他元素的时候，主动失去焦点
                  if (this.geditCell !== ref) {
                    if (this.geditCell && this.geditCell.current) {
                      let dd =
                        this.geditCell.current.querySelector(".content-edit");
                      if (dd.onblur) dd.onblur();
                      console.log(dd);
                    }
                  }
                  if (this.editStatus === this.CELLEDITSTATE.NORMAL) {
                    if (1 !== e.detail || !this.geditCell) {
                      if (!this.currentTime) {
                        //防止出现多次setTimeout
                        this.currentTime = setTimeout(function () {
                          ref.current.click();
                        }, 300);
                      }
                    }
                  }
                }}
                onDoubleClick={(e) => {
                  if (this.editStatus === this.CELLEDITSTATE.NORMAL) {
                    this.setRefStatus(ref.current, this.CELLEDITSTATE.LOADING);
                    this.cleanCurrentTime();
                    this.dataManager.getRowData(
                      ref.current,
                      rowData,
                      (form) => {
                        this.setRefStatus(
                          ref.current,
                          this.CELLEDITSTATE.EDITING
                        );
                        this.geditCell = ref;
                        let merger = { ...rowData, ...form.form.fieldData }; //子表单的信息每行会有单独记录，先简单合并，

                        let widget1 = this.getWidgetItems(
                          widget,
                          form.form,
                          merger
                        );
                        this.clickEditCell(
                          e,
                          value,
                          widget1,
                          merger,
                          form.form
                        );
                      }
                    );
                  }
                }}
              >
                <div
                  className="value-components"
                  style={{ border: "none", outline: "none" }}
                >
                  {textElements}
                </div>
                <BsySLoading customCls={"small"} style={{ display: "none" }} />
                <div
                  className="field-components"
                  style={{ display: "none", background: "#fff" }}
                ></div>
              </div>
              <i
                className="x-icon icon-edit"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();

                  if (this.editStatus === this.CELLEDITSTATE.NORMAL) {
                    this.setRefStatus(ref.current, this.CELLEDITSTATE.LOADING);
                    this.dataManager.getRowData(
                      ref.current,
                      rowData,
                      (form) => {
                        this.setRefStatus(
                          ref.current,
                          this.CELLEDITSTATE.EDITING
                        );
                        this.geditCell = ref;
                        let merger = { ...rowData, ...form.form.fieldData }; //子表单的信息每行会有单独记录，先简单合并

                        let widget1 = this.getWidgetItems(
                          widget,
                          form.form,
                          merger
                        );

                        this.clickEditCell(
                          e,
                          value,
                          widget1,
                          merger,
                          form.form
                        );
                      }
                    );
                  }
                }}
              />
            </div>
          </>
        ) : (
          <>
            <div className="bsy-td-background"></div>
            {textElements}
          </>
        )}
      </>
    );
  };

  //获取字段是否可见 针对仅详细可见的情况
  getWidgetVisible = (widget) => {
    if (
      this.props.type === "data_table" ||
      this.state.chartType === "data_table"
    ) {
      if (!this.widgetMap.hasOwnProperty(widget)) {
        return false;
      }
      if (this.widgetMap[widget].isEditable === true) {
        return true;
      }
      if (this.widgetMap[widget].detailOnly) {
        return false;
      }
    }
    return true;
  };

  getWidgetItems = (widget, form, data) => {
    const subform = widget.subformWidgetName || widget.subform;

    widget.rowIdx = subform ? data[widget.subform + "-row-index"] : -1;
    widget.rowId = subform ? data[widget.subform + "-row-rid"] : "";

    if (form) {
      switch (widget.type) {
        case "combo":
        case "radiogroup":
        case "checkboxgroup":
        case "combocheck": {
          if (subform) {
            let opt = form.getOptions(
              [subform, widget.name].join("."),
              widget.rowIdx
            );
            widget.items = opt.items;
            widget.rely = opt.rely;
            widget.async = opt.async;
          } else {
            let opt = form.getOptions(widget.name);
            widget.items = opt.items;
            widget.rely = opt.rely;
            widget.async = opt.async;
          }

          break;
        }

        case "dept":
        case "user":
        case "deptgroup":
        case "usergroup": {
          if (subform) {
            let opt = form.getOptions(
              [subform, widget.name].join("."),
              widget.rowIdx
            );
            widget.limit = opt.limit;
            widget.limitWidget = opt.limitWidget;
            widget.rely = opt.rely;
          } else {
            let opt = form.getOptions(widget.name);
            widget.limit = opt.limit;
            widget.limitWidget = opt.limitWidget;
            widget.valueOption = opt.valueOption;
            widget.rely = opt.rely;
            widget.async = opt.async;
          }
          break;
        }
        default: {
        }
      }
    }

    return {
      ...widget,
      subform,
    };
  };

  cleanCurrentTime = () => {
    if (this.currentTime) {
      clearTimeout(this.currentTime);
      this.currentTime = null;
    }
  };

  setRefStatus(ref, status) {
    if (!ref) {
      return;
    }
    let statusString = ["loading", "editing", "focus"];
    let editEl = ref.querySelector(".content-edit");
    this.editStatus = status;
    for (let i = 0; i < statusString.length; i++) {
      if (editEl) editEl.classList.remove(statusString[i]);
      ref.classList.remove(statusString[i]);
    }
    switch (status) {
      case this.CELLEDITSTATE.NORMAL: {
        this.currentTime = null;
        break;
      }
      case this.CELLEDITSTATE.LOADING: {
        editEl.classList.add(statusString[status - 1]);
        break;
      }
      case this.CELLEDITSTATE.EDITING: {
        editEl.classList.add("focus");
        editEl.classList.add(statusString[status - 1]);
        ref.classList.add(statusString[status - 1]);

        break;
      }

      default: {
      }
    }
  }

  formLoadLayer = (element) => {
    // return
    // this.LoadLayer && this.LoadLayer.remove();
    // this.LoadLayer = FX.Utils.createLoadLayer(this.element, {
    //     hasLoader: !0,
    //     isLight: !0
    // })
  };

  formLoadLayerRemove = (element) => {
    // this.LoadLayer && this.LoadLayer.remove();
    // this.LoadLayer = null;
  };

  renderText = (t, widget) => {
    t = BsyUtils.getAddressText(BsyUtils.toStringDetailed(t).trim());

    let i = BsyConfig().CONST.TEXT_TYPE_REGEXP.URL;
    let a = t.split(new RegExp("(" + i + ")"));

    return (
      <span title={t} className={"table-text"}>
        {a.map((dd, index) => {
          if (index % 2 !== 0) {
            let a1 = dd;
            if (BsyUtils.startWith(a1, "www")) {
              a1 = "http://" + a1;
            }
            return (
              <a
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className="nest-link"
                target="_blank"
                rel="noreferrer"
                href={a1}
              >
                {dd}
              </a>
            );
          }
          return this.highlighterText(dd, widget);
        })}
      </span>
    );
  };

  getForms = () => {
    let appId = this.props.appId;
    let formId = this.props.formId || this.props.entryId;
    let refAppId = undefined;
    if (this.props.type == "data_table") {
      //数据表的时候
      if (this.props.forms[0].indexOf("@") > -1) {
        let forms = this.props.forms[0].split("@");
        refAppId = forms[1];
        formId = forms[0];
        appId = forms[1];
      } else {
        formId = this.props.forms[0];
      }
    } else {
      //查看原始数据的时候
      if (this.props.extDashData) {
        if (this.props.extDashData.formId.indexOf("@") > -1) {
          let forms = this.props.extDashData.formId.split("@");
          refAppId = forms[1];
          formId = forms[0];
          appId = forms[1];
        }
      }
    }
    return { appId, formId, entryId: formId, refAppId };
  };

  findSubformIndex = (subVal, id) => {
    return subVal.findIndex((e) => e.id === id);
  };

  findSubformRid = (subVal, idx) => {
    return subVal[idx].id;
  };

  //创建组件
  createComponents = (
    widget,
    value,
    onstop,
    onclose,
    getContext,
    rowData,
    form
  ) => {
    let name = this.getWidgetName(widget);
    let widgetarrt = { ...this.widgetMap[name] };
    const rowIdx = widget.rowIdx;
    const rowId = widget.rowId;
    widgetarrt.is_dock_form = this.state.is_dock_form;
    widgetarrt.visible = true;
    widgetarrt.enable = true;
    widgetarrt.rely = widget.rely;
    widgetarrt.async = widget.async;
    widgetarrt.subform = widget.subform;
    widgetarrt.widgetName = widget.widgetName || widget.name;
    widgetarrt.extendSet = widget.extendSet;
    widgetarrt.theme = this.props.theme;
    switch (widget.type) {
      case "combo":
      case "radiogroup":
      case "checkboxgroup":
      case "combocheck": {
        widgetarrt.items = widget.items;
        break;
      }
      case "dept":
      case "user":
      case "deptgroup":
      case "usergroup": {
        widgetarrt.limit = widget.limit;
        widgetarrt.limitWidget = widget.limitWidget;
        widgetarrt.valueOption = widget.valueOption;
        break;
      }
      default:
    }

    let val = rowData[name]; //|| value;//考虑子表单要行数的问题，暂时先不动
    let subindex = -1;
    if (widget.subform) {
      let subname = name.split(".");
      if (rowData[subname[0]]) {
        subindex = this.findSubformIndex(rowData[subname[0]], rowId);
        if (rowData[subname[0]][subindex]) {
          val = rowData[subname[0]][subindex][subname[1]];
        }
      }
    }

    switch (widgetarrt.type) {
      case "upload": {
        let val1 = val ? [...val] : null;
        let online_edit = false;
        let online_edit_record = false;
        let is_file_down = false;
        let enable = false;
        const optAuth1 = form.optAuth;
        // eslint-disable-next-line array-callback-return
        if (optAuth1) {
          if (widget.subform) {
            const sAuth = optAuth1[widget.subformWidgetName];
            const auth = optAuth1[widget.subformWidgetName + "." + widget.name];
            if (auth) {
              online_edit = auth.online_edit;
              online_edit_record = auth.online_edit_record;
              is_file_down = auth.is_file_down;
              enable = auth.enable && sAuth.subform_edit;
            }
          } else {
            const auth = optAuth1[widget.name];
            if (auth) {
              online_edit = auth.online_edit;
              online_edit_record = auth.online_edit_record;
              is_file_down = auth.is_file_down;
              enable = auth.enable;
            }
          }
        }
        return (
          <BsySubformFileUpload
            {...widgetarrt}
            idx={subindex}
            scene={"datatable"}
            download={false}
            dataId={rowData._id}
            formId={form.formId}
            appId={form.appId}
            getContext={getContext}
            value={val1}
            online_edit={online_edit && enable}
            online_edit_record={online_edit_record}
            is_file_down={is_file_down}
            onStopEdit={(t) => {
              onstop(t);
            }}
            onClose={(t) => {
              onclose(val1);
            }}
            onFileSizeLimit={() => {
              return BsyUtils.Vip.getUploadMFS();
            }}
          />
        );
      }
      case "image": {
        let val1 = val ? [...val] : null;
        let is_file_down = false;
        const optAuth1 = form.optAuth;
        // eslint-disable-next-line array-callback-return
        if (optAuth1) {
          if (widget.subform) {
            const auth = optAuth1[widget.subformWidgetName + "." + widget.name];
            if (auth) {
              is_file_down = auth.is_file_down;
            }
          } else {
            const auth = optAuth1[widget.name];
            if (auth) {
              is_file_down = auth.is_file_down;
            }
          }
        }
        return (
          <BsySubformImageUpload
            {...widgetarrt}
            download={false}
            dataId={rowData._id}
            formId={form.formId}
            appId={form.appId}
            getContext={getContext}
            value={val1}
            is_file_down={is_file_down}
            onGetFormData={() => {
              return rowData;
            }}
            onStopEdit={(t) => {
              onstop(t);
            }}
            onClose={(t) => {
              onclose(val1);
            }}
            onFileSizeLimit={() => {
              return BsyUtils.Vip.getUploadMFS();
            }}
          />
        );
      }
      case "signature": {
        let val1 = val ? [...val] : null;

        return (
          <BsySubformSignature
            getContext={getContext}
            {...widgetarrt}
            value={val1}
            onStopEdit={(t) => {
              onstop(t);
            }}
            onFileSizeLimit={() => {
              return BsyUtils.Vip.getUploadMFS();
            }}
            onClose={(t) => {
              onclose(val1);
            }}
          />
        );
      }

      case "address": {
        let val1 = val ? { ...val } : null;

        return (
          <BsySubformAddress
            getContext={getContext}
            // format={widget.format}
            {...widgetarrt}
            width={"auto"}
            customCls={"sub-cell-widget"}
            value={val1}
            onStopEdit={(t) => {
              onstop(t);
            }}
            onClose={(t) => {
              onclose(val1);
            }}
          />
        );
      }
      case "user": {
        let val1 = val
          ? BsyUtils.isString(val)
            ? val
            : val.id || val._id
          : "";

        return (
          <BsySelectUser
            getContext={getContext}
            {...widgetarrt}
            value={val1}
            width={"auto"}
            customCls={"sub-cell-widget"}
            onBeforeEdit={(e) => {
              let a = e.options;
              if (a.limitWidget) {
                let subrow = -1;
                if (a.limitWidget.indexOf(".") > -1) {
                  subrow = rowData[a.limitWidget.split(".")[0] + "-row-index"];
                }

                let b = form.rowRely.getFieldIndex(a.limitWidget, subrow);
                if (b) {
                  switch (b.type) {
                    case "dept":
                    case "subform_dept": {
                      let d = b.getLinkValue();
                      if (!BsyUtils.isNull(d)) {
                        if (BsyUtils.isArray(d)) {
                          a.limit = d;
                        } else {
                          a.limit = [d];
                        }
                      } else {
                        a.limit = [];
                      }
                      break;
                    }

                    case "deptgroup":
                    case "subform_deptgroup": {
                      let d = b.getLinkValue();
                      if (!BsyUtils.isNull(d)) {
                        if (BsyUtils.isArray(d)) {
                          a.limit = d;
                        } else {
                          a.limit = [d];
                        }
                      } else {
                        a.limit = [];
                      }
                      break;
                    }

                    default:
                  }
                }
              }
            }}
            onStopEdit={(t, item) => {
              if (item && val1 === (item.id || item._id)) {
                onclose(item);
              } else {
                onstop(item);
              }
            }}
            onClose={(t) => {
              onclose(val);
            }}
          />
        );
      }
      case "dept": {
        let val1 = val
          ? BsyUtils.isString(val)
            ? val
            : val.id || val._id
          : "";

        return (
          <BsySelectDept
            getContext={getContext}
            {...widgetarrt}
            width={"auto"}
            customCls={"sub-cell-widget"}
            value={val1}
            onRelyLimit={(cb, widget) => {
              if (cb) {
                let ddthis = widget;
                let k = widget.options.rely.data
                  ? { ...widget.options.rely.data }
                  : {};
                k.widgetName = widget.options.widgetName;
                k.subformName = widget.options.subform;

                let ret = this.getForms();
                let appId = ret.appId;
                let formId = ret.formId;

                k.designAppId = appId;
                k.designEntryId = formId;
                k.appId = appId;
                k.entryId = formId;
                k.dataId = rowData._id;
                let refFieldId = k.subformName
                  ? [k.subformName, k.widgetName].join(".")
                  : k.widgetName;
                k.filter = form.rowRely._iterAddFilter(
                  form.rowRely.getFieldIndex(refFieldId, widget.options.rowIdx)
                );
                // k.filter = form.rowRely._iterAddFilter(widget)
                k.deptExist = true;
                if (!BsyUtils.isObjectEmpty(k.filter)) {
                  window.FX.Utils.dataAjax(
                    {
                      url: "/data/distinct",
                      data: k,
                    },
                    function (a) {
                      let limit = [];
                      BsyUtils.forEach(a.items, function (a1, b1) {
                        if (
                          b1.hasOwnProperty("_id") ||
                          b1.hasOwnProperty("id")
                        ) {
                          limit.push(b1._id || b1.id);
                        } else {
                          limit.push(b1);
                        }
                      });
                      ddthis.options.limit = limit;
                      cb && cb();
                    }
                  );
                }
              }
            }}
            onStopEdit={(t, item) => {
              if (item && val1 === (item.id || item._id)) {
                onclose(item);
              } else {
                onstop(item);
              }
            }}
            onClose={(t) => {
              onclose(val);
            }}
          />
        );
      }

      case "usergroup": {
        let val1 = val ? [...val] : [];
        let ids = BsyUtils.getUserDeptId(val1);
        return (
          <BsySelectUserGroup
            getContext={getContext}
            {...widgetarrt}
            value={ids}
            width={"auto"}
            customCls={"sub-cell-widget"}
            onBeforeEdit={(e) => {
              let a = e.options;
              if (a.limitWidget) {
                let subrow = -1;
                if (a.limitWidget.indexOf(".") > -1) {
                  subrow = rowData[a.limitWidget.split(".")[0] + "-row-index"];
                }

                let b = form.rowRely.getFieldIndex(a.limitWidget, subrow);
                if (b) {
                  switch (b.type) {
                    case "dept":
                    case "subform_dept": {
                      let d = b.getLinkValue();
                      if (!BsyUtils.isNull(d)) {
                        if (BsyUtils.isArray(d)) {
                          a.limit = d;
                        } else {
                          a.limit = [d];
                        }
                      } else {
                        a.limit = [];
                      }
                      break;
                    }

                    case "deptgroup":
                    case "subform_deptgroup": {
                      let d = b.getLinkValue();
                      if (!BsyUtils.isNull(d)) {
                        if (BsyUtils.isArray(d)) {
                          a.limit = d;
                        } else {
                          a.limit = [d];
                        }
                      } else {
                        a.limit = [];
                      }
                      break;
                    }

                    default:
                  }
                }
              }
            }}
            onStopEdit={(t, item) => {
              let newids = BsyUtils.getUserDeptId(item ? item : []);
              if (isEqual(ids, newids)) {
                onclose(item);
              } else {
                onstop(item);
              }
            }}
            onClose={(t) => {
              onclose(val);
            }}
          />
        );
      }
      case "deptgroup": {
        let val1 = val ? [...val] : [];
        let ids = BsyUtils.getUserDeptId(val1);

        return (
          <BsySelectDeptGroup
            getContext={getContext}
            {...widgetarrt}
            width={"auto"}
            customCls={"sub-cell-widget"}
            value={ids}
            onRelyLimit={(cb, widget) => {
              if (cb) {
                let ddthis = widget;
                let k = widget.options.rely.data
                  ? { ...widget.options.rely.data }
                  : {};
                k.widgetName = widget.options.widgetName;
                k.subformName = widget.options.subform;

                let ret = this.getForms();
                let appId = ret.appId;
                let formId = ret.formId;

                k.designAppId = appId;
                k.designEntryId = formId;
                k.appId = appId;
                k.entryId = formId;
                k.dataId = rowData._id;
                // k.filter = form.rowRely._iterAddFilter(widget)
                let refFieldId = k.subformName
                  ? [k.subformName, k.widgetName].join(".")
                  : k.widgetName;
                k.filter = form.rowRely._iterAddFilter(
                  form.rowRely.getFieldIndex(refFieldId, widget.options.rowIdx)
                );

                k.deptExist = true;
                if (!BsyUtils.isObjectEmpty(k.filter)) {
                  window.FX.Utils.dataAjax(
                    {
                      url: "/data/distinct",
                      data: k,
                    },
                    function (a) {
                      let limit = [];
                      BsyUtils.forEach(a.items, function (a1, b1) {
                        if (
                          b1.hasOwnProperty("_id") ||
                          b1.hasOwnProperty("id")
                        ) {
                          limit.push(b1._id || b1.id);
                        } else {
                          limit.push(b1);
                        }
                      });
                      ddthis.options.limit = limit;
                      cb && cb();
                    }
                  );
                }
              }
            }}
            onStopEdit={(t, item) => {
              let newids = BsyUtils.getUserDeptId(item ? item : []);
              if (isEqual(ids, newids)) {
                onclose(item);
              } else {
                onstop(item);
              }
            }}
            onClose={(t) => {
              onclose(val);
            }}
          />
        );
      }
      case "radiogroup": {
        return (
          <BsySubformRadioGroup
            getContext={getContext}
            {...widgetarrt}
            value={val}
            width={"auto"}
            customCls={"sub-cell-widget"}
            // items={widget.items}
            onStopEdit={(t, sec, context) => {
              if (t == val) {
                onclose(t);
              } else onstop(t, sec, context);
            }}
            onClose={(t) => {
              onclose(val);
            }}
          />
        );
      }

      case "checkboxgroup": {
        return (
          <BsySubformCheckboxGroup
            getContext={getContext}
            {...widgetarrt}
            value={val}
            width={"auto"}
            customCls={"sub-cell-widget"}
            // items={widget.items}
            onStopEdit={(t, sec, context) => {
              if (t == val) {
                onclose(t);
              } else onstop(t, sec, context);
            }}
            onClose={(t) => {
              onclose(t);
            }}
          />
        );
      }
      case "combocheck":
        let ret = this.getForms();
        return (
          <BsyComboCheckBox
            getContext={getContext}
            {...widgetarrt}
            width={"auto"}
            customCls={"sub-cell-widget"}
            appId={ret.appId}
            formId={ret.formId}
            designAppId={ret.appId}
            designEntryId={ret.formId}
            value={val}
            onBeforeAsync={() => {
              if (widgetarrt.async.data && form && form.rowRely) {
                let filter = form.rowRely._iterAddFilter(
                  form.rowRely.getFieldIndex(name, subindex),
                  null
                );
                return filter;
              } else {
                return null;
              }
            }}
            onStopEdit={(t, sec, context) => {
              if (t == val) {
                onclose(t);
              } else onstop(t, sec, context);
            }}
            onClose={(t) => {
              onclose(t);
            }}
          />
        );
      case "combo":
        let ret1 = this.getForms();
        // if (widgetarrt.async) {
        return (
          <BsyComboBox
            getContext={getContext}
            appId={ret1.appId}
            formId={ret1.formId}
            designAppId={ret1.appId}
            designEntryId={ret1.formId}
            // subform={"subform"}
            width={"auto"}
            customCls={"sub-cell-widget"}
            onBeforeAsync={() => {
              if (widgetarrt.async.data && form && form.rowRely) {
                let filter = form.rowRely._iterAddFilter(
                  form.rowRely.getFieldIndex(name, subindex),
                  null
                );
                return filter;
              } else {
                return null;
              }
            }}
            {...widgetarrt}
            value={val}
            // items={widget.items}
            onStopEdit={(t, sec, context) => {
              if (t == val) {
                onclose(t);
              } else onstop(t, sec, context);
            }}
            onClose={(t) => {
              onclose(t);
            }}
          />
        );
      // }

      // return <BsySubformSelectPane
      //   getContext={getContext}
      //   {...widgetarrt}
      //   value={val}
      //   width={'auto'}
      //   customCls={'sub-cell-widget'}
      //   // items={widget.items}
      //   onStopEdit={(t, sec, context) => {
      //     if (t == val) {
      //       onclose(t)
      //     } else
      //       onstop(t, sec, context)
      //   }}
      //   onClose={(t) => {
      //     onclose(t)
      //   }}
      // />

      case "datetime": {
        let format = widget.format;
        switch (format) {
          case "yyyy-MM-dd HH:mm:ss":
          case "yyyy-MM-dd":
          case "yyyy-MM":
          case "yyyy": {
            break;
          }
          default: {
            widgetarrt.format = "yyyy-MM-dd";
            break;
          }
        }

        let val1 = val ? new Date(val).getTime() : null;

        return (
          <BsyDateTime
            getContext={getContext}
            // format={widget.format ? widget.format : "yyyy-MM-dd"}
            {...widgetarrt}
            width={"auto"}
            customCls={"sub-cell-widget"}
            value={val1}
            onClose={(t) => {
              onclose(t);
            }}
            onStopEdit={(t, sec, context) => {
              if (t !== val1) {
                onstop(t, sec, context);
              }
            }}
          />
        );
      }

      case "number": {
        return (
          <BsyNumber
            getContext={getContext}
            {...widgetarrt}
            inputTag={"textarea"}
            value={val && val.hasOwnProperty("value") ? val.value : val}
            onStopEdit={(t, sec, context) => {
              if (t == val) {
                onclose(t);
              } else onstop(t, sec, context);
            }}
          />
        );
      }
      case "textarea": {
        return (
          <BsySubformTextArea
            getContext={getContext}
            {...widgetarrt}
            value={val}
            width={400}
            height={300}
            onStopEdit={(t, sec, context) => {
              if (t == val) {
                onclose(t);
              } else onstop(t, sec, context);
            }}
          />
        );
      }
      case "text":
      case "sn":
      default: {
        if (BsyConfig().CONST.TEXT_TYPE_REGEXP.HMS == widgetarrt.regex) {
          return (
            <BsySubformTextEditor
              getContext={getContext}
              regex={widgetarrt.regex}
              format={"HH:mm:ss"}
              value={val}
              onStopEdit={(t, sec, context) => {
                if (t == val) {
                  onclose(t);
                } else onstop(t, sec, context);
              }}
            />
          );
        } else if (BsyConfig().CONST.TEXT_TYPE_REGEXP.HM == widgetarrt.regex) {
          return (
            <BsySubformTextEditor
              getContext={getContext}
              regex={widgetarrt.regex}
              format={"HH:mm"}
              value={val}
              onStopEdit={(t, sec, context) => {
                if (!t) {
                  if (
                    BsyUtils.isObjectEmpty(t) == BsyUtils.isObjectEmpty(val)
                  ) {
                    onclose(t);
                  } else onstop(t, sec, context);
                } else {
                  if (t == val) {
                    onclose(t);
                  } else onstop(t, sec, context);
                }
              }}
            />
          );
        } else {
          return (
            <BsyTextEditor
              getContext={getContext}
              {...widgetarrt}
              triggerEvent={0}
              value={val}
              inputTag={"textarea"}
              onStopEdit={(t, sec, context) => {
                if (!t) {
                  if (
                    BsyUtils.isObjectEmpty(t) == BsyUtils.isObjectEmpty(val)
                  ) {
                    onclose(t);
                  } else onstop(t, sec, context);
                } else {
                  if (t == val) {
                    onclose(t);
                  } else onstop(t, sec, context);
                }
              }}
            />
          );
        }
      }
    }
  };

  renderEditAfterCell = (editEl, widget, value, rowData, subrow) => {
    console.log("renderEditAfterCell");
    let name = widget.widgetName || widget.name;

    if (!name) {
      return;
    }
    const t = widget.subform ? [widget.subform, name].join(".") : name;
    if (editEl.classList.contains("editing")) {
      return;
    }
    if (widget.type === "button") {
      return;
    }

    if (this.widgetMap[t]) {
      widget = { ...this.widgetMap[t] };
    }

    if (
      [
        "creator",
        "createTime",
        "updateTime",
        "_id",
        "label",
        "assist_protime",
        "assist_outtime",
      ].includes(name)
    ) {
      let textElements = this.cellElements(value, widget, rowData);
      if (editEl) {
        ReactDOM.unmountComponentAtNode(editEl);
      }
      ReactDOM.render(textElements, editEl);
      return;
    }

    var td = BsyUtils.closestClass(editEl, "art-table-cell");
    if (!td) {
      return;
    }
    td.classList.remove("error-info");
    td.setAttribute("data-error-tip", "");
    let valuecomponents = td.querySelector(".value-components");
    let textElements = this.cellElements(value, widget, rowData);

    if (!valuecomponents) {
      //无权限的情况
      if (editEl) {
        ReactDOM.unmountComponentAtNode(editEl);
      }
      ReactDOM.render(textElements, editEl);
      return;
    }

    let fieldcomponents = td.querySelector(".field-components");
    fieldcomponents.style.display = "none";
    valuecomponents.style.visibility = "";

    if (valuecomponents) {
      ReactDOM.unmountComponentAtNode(valuecomponents);
    }
    ReactDOM.render(textElements, valuecomponents);

    let tr = BsyUtils.closestClass(editEl, "art-table-row");
    if (tr) {
      let id = tr.getAttribute("dataid");
      let td = BsyUtils.closestClass(editEl, "art-table-cell");
      if (widget.subform) {
        widget.subform = this.widgetMap[widget.subform]
          ? this.widgetMap[widget.subform].tag ||
          this.widgetMap[widget.subform].name
          : widget.subform;
      }
      let subformrow = parseInt(td.getAttribute("subformrow"));
      if (isNaN(subformrow)) {
        subformrow = subrow;
      }
      //实时更新缓存数据
      this.updateDataSourceCache(id, widget, value, subformrow);
    }
    // }
  };

  renderErrorTip = (editEl, errorinfo) => {
    console.log("renderErrorTip");
    var td = BsyUtils.closestClass(editEl, "art-table-cell");
    if (td) {
      if (errorinfo) {
        this.setPointerEvent(false, editEl);
        td.classList.add("error-info");
      } else {
        td.classList.remove("error-info");
      }
      td.setAttribute("data-error-tip", errorinfo);
    }
  };

  renderRowFieldErrorTip = (dataId, errorinfo) => {
    console.log("renderRowFieldErrorTip");
    let selector = ".row-id-" + dataId;
    if (!this.element.current) {
      return;
    }
    let a = this.element.current.querySelectorAll(selector);
    for (let i = 0; i < a.length; i++) {
      //先请理掉已有的错误 然后增加
      a[i].classList.remove("field-error");
      a[i].classList.remove("verify-error");
      a[i].setAttribute("verify-error-info", "");

      if (errorinfo) {
        a[i].classList.add("field-error");
        a[i].setAttribute("verify-error-info", errorinfo);
      } else {
        let edits = a[i].querySelectorAll(".content-edit");
        var td = a[i].querySelectorAll(".art-table-cell");
        //清理错误的选中项目
        for (let index = 0; index < edits.length; index++) {
          edits[index].classList.remove("error-info");
          edits[index].setAttribute("data-error-tip", "");
        }
        for (let index = 0; index < td.length; index++) {
          td[index].classList.remove("error-info");
        }
      }
    }
  };

  renderRowErrorTip = (dataId, errorinfo) => {
    console.log("renderRowErrorTip");

    let selector = ".row-id-" + dataId;
    if (!this.element.current) {
      return;
    }
    let a = this.element.current.querySelectorAll(selector);
    for (let i = 0; i < a.length; i++) {
      //先请理掉已有的错误 然后增加
      a[i].classList.remove("verify-error");
      a[i].classList.remove("linking");
      a[i].setAttribute("verify-error-info", "");
      if (errorinfo) {
        a[i].classList.add("verify-error");
        a[i].setAttribute("verify-error-info", errorinfo);
      } else {
        let edits = a[i].querySelectorAll(".content-edit");
        var td = a[i].querySelectorAll(".art-table-cell");
        //清理错误的选中项目
        for (let index = 0; index < edits.length; index++) {
          edits[index].classList.remove("error-info");
          edits[index].setAttribute("data-error-tip", "");
        }
        for (let index = 0; index < td.length; index++) {
          td[index].classList.remove("error-info");
        }
      }
    }
  };

  renderRowLinkingTip = (dataId, errorinfo) => {
    let selector = ".row-id-" + dataId;

    if (!this.element.current) {
      return;
    }

    let a = this.element.current.querySelectorAll(selector);
    for (let i = 0; i < a.length; i++) {
      //先请理掉已有的错误 然后增加
      // a[i].classList.remove('verify-error');
      a[i].classList.remove("linking");

      if (errorinfo) {
        a[i].classList.add("linking");
      }
    }
  };

  setPointerEvent(isFocus, editEl) {
    // const el = window.$(editEl);
    // const $td = el.closest("td");
    // const $table = el.closest("table");
    // if (isFocus) {
    //   $td.css("pointer-events", "auto");
    //   $table.css("pointer-events", "none");
    // } else {
    //   $td.css("pointer-events", "");
    //   $table.css("pointer-events", "");
    // }
  }

  //单元格编辑
  clickEditCell = (e, value, widget, rowData, form) => {
    let widgetName = this.getWidgetName({
      ...widget,
      subform: widget.subformWidgetName,
    });
    const subform = widget.subformWidgetName || widget.subform;
    let editEl = this.geditCell?.current?.querySelector?.(".content-edit");
    this.setPointerEvent(true, editEl);
    let onblur = (e) => {
      this.setPointerEvent(false, editEl);
      e.target.classList.remove("focus");
      // editEl.removeEventListener("blur", onblur);
      document.removeEventListener("keydown", keydown);
    };

    let keydown = (e) => {
      // let t;
      if (e.keyCode === BsyConfig().CONST.KEY_CODE.ESC) {
        this.cellEditGetFocus(editEl);
        document.removeEventListener("keydown", keydown);
        this.setPointerEvent(false, editEl);
      }
    };
    if (typeof editEl.onblur !== "function") {
      editEl.addEventListener("blur", onblur, false);
    }
    document.addEventListener("keydown", keydown, false);

    this.scrollLeft = this.getTableScrollLeft();
    this.scrollTop = this.getTableScrollTop();

    let selectFieldComponent = null;

    const loading = editEl?.querySelector(".BsySLoading");
    const fieldComponents = editEl?.querySelector(".field-components");
    const valueComponents = editEl?.querySelector(".value-components");
    const rowIdx = widget.rowIdx;
    const rowId = widget.rowId;
    loading.style.display = "none";
    fieldComponents.style.display = "";
    fieldComponents.style.zIndex = "2";
    valueComponents.style.visibility = "hidden";
    const node = this.createComponents(
      widget,
      value,
      (val) => {
        //onStopEdit
        editEl?.classList?.remove?.("editing");
        this.renderEditAfterCell(editEl, widget, val, rowData);
        this.cellEditGetFocus(editEl);
        let subrowIndex = null;
        if (subform) {
          //子表单的单行编辑
          subrowIndex = this.findSubformIndex(rowData[subform], rowId); //rowData[widget.subform + "-row-index"];
          //数据表，需要转换id;
          let dd = widgetName.split(".");
          if (this.props.type === "data_table") {
            widgetName = this.widgetMap[subform].name + "." + dd[1];
          } else widgetName = subform + "." + dd[1];
        } else {
          if (widgetName.indexOf("f_") > -1) {
            widgetName = this.widgetMap[widgetName].name;
          }
        }

        switch (widget.type) {
          case "radiogroup":
          case "combo":
          case "checkboxgroup":
          case "combocheck": {
            form.setFieldValueMap(
              widgetName,
              selectFieldComponent.valueMap,
              subrowIndex
            );
            break;
          }
          default:
        }
        form.setFieldValue(widgetName, val, subrowIndex, 1, rowId);
        form.updateData();
        this.setPointerEvent(false, editEl);
      },
      (val) => {
        fieldComponents.style.display = "none";
        valueComponents.style.visibility = "";
        this.cellEditGetFocus(editEl);
      },
      (component) => {
        selectFieldComponent = component;
        if (component.input && component.input.current) {
          // component.input &&
          //   component.input.current &&
          component.input.current.focus();
          let pos = component.input.current.value.length;
          component.input.current.setSelectionRange(pos, pos);
        } else {
          component.element.current && component.element.current.click();
        }
      },
      rowData,
      form
    );
    if (fieldComponents) {
      ReactDOM.unmountComponentAtNode(fieldComponents);
    }
    ReactDOM.render(node, fieldComponents);
  };

  cellEditGetFocus = (editEl) => {
    let that = this;
    setTimeout(() => {
      if (!that.geditCell || !that.geditCell.current) {
        // let editEl = that.geditCell.current.querySelector(".content-edit");
        that.geditCell = {
          current: BsyUtils.closestClass(editEl, "bsy-edit-cell"),
        };
      }
      that.setRefStatus(that.geditCell.current, that.CELLEDITSTATE.NORMAL);

      if (
        that.scrollLeft === this.getTableScrollLeft() &&
        that.scrollTop === this.getTableScrollTop()
      ) {
        editEl?.classList?.add?.("focus");
        editEl?.focus();
      }

      that.geditCell = null;
      that.currentTime = null;
      that.editStatus = that.CELLEDITSTATE.NORMAL;
    }, 2);
  };

  previewCanves = (cansv, widget) => {
    new window.FX.FilePreview({
      widgetType: "image",
      fieldName: widget.name,
      title: widget.title || widget.text,
      files: [{ imageUrl: cansv.toDataURL() }],
      currentItem: 0,
      autoClose: !1,
    });
  };

  renderAllPermission = (value, header, optAuth) => {
    if (
      optAuth &&
      optAuth[header.name] &&
      optAuth[header.name].visible === false
    ) {
      return (
        <div className="cell-no-auth">
          {React.language("field.no_view_auth")}
        </div>
      );
    }
    //处理子表单
    if (
      optAuth &&
      optAuth[header.subform] &&
      optAuth[[header.subform, header.name].join(".")].visible === false
    ) {
      return (
        <div className="cell-no-auth">
          {React.language("field.no_view_auth")}
        </div>
      );
    }
    return null;
  };
  // 取字段的原始结构
  getFormWidget = (header) => {
    // console.log(header);
    const { formItems = [] } = this.state;
    if (header.subform) {
      let subform = formItems.find(
        (item) => item.widget.widgetName === header.subform
      );
      return subform
        ? subform.widget.items.find(
          (item) => item.widget.widgetName === header.name
        )
        : null;
    } else {
      return formItems.find((item) => item.widget.widgetName === header.name);
    }
  };

  //自定义单元格
  renderCustomCell = (value, record, rowIndex, header, menuColWidth) => {
    const { authGroupId, quickEdit, optAuth } = this.state;

    // console.log(header.type)
    // 报表 数据表中使用

    if (authGroupId === 0) {
      let ret = this.renderAllPermission(value, header, record.optAuth);
      if (ret) {
        return ret;
      }
      // _optAuth
    }

    if (header.isdel) {
      return (
        <div className="cell-no-auth">
          {React.language("field.no_view_auth")}
        </div>
      );
    }

    switch (header.type) {
      case "menu": {
        return this.renderDataMenu(record, menuColWidth);
      }
      case "textarea":
      case "sn":
      case "text":
      case "formula":
      case "number":
      case "datetime":
      case "radiogroup":
      case "combo":
      case "checkboxgroup":
      case "combocheck":
      case "array":
      case "user":
      case "usergroup":
      case "dept":
      case "deptgroup":
      case "upload":
      case "image":
      case "signature":
      case "address": {
        return this.renderCellText(value, header, record);
      }

      case "location": {
        let dd = {};
        try {
          if (BsyUtils.isString(value)) {
            dd = CircularJSON.parse(value);
          } else {
            dd = value;
          }
        } catch (error) {
          dd = null;
        }
        value = BsyUtils.address2Str(dd, header.format || "pcda", "-");
        return (
          <div title={value} className={"table-text"}>
            {value}
          </div>
        );
      }
      case "flowstate":
      case "flowState": {
        return BsyUtils._getFlowState(value);
      }
      case "flowdecision":
      case "flowDecision": {
        if (value) {
          if (value.state) {
            return (
              <div title={value.state} className={"table-text"}>
                {value.state}
              </div>
            );
          }
        }
        return "";
      }

      case "assist_flowid": {
        let dd = {};
        try {
          dd = CircularJSON.parse(value);
        } catch (error) {
          dd = null;
        }
        return dd && dd.flowName;
      }
      case "assist_prostatus": {
        let dd = {};
        try {
          dd = CircularJSON.parse(value);
        } catch (error) {
          dd = null;
        }
        return dd && dd.text;
      }
      case "button": {
        let style = {};

        let widgetName = this.getWidgetName(header);
        let witem = this.getFormWidget(header);
        let enable = true;
        if (authGroupId === 0) {
          let rowOptAuth = record.optAuth;
          enable = this.getOptAuth(rowOptAuth, widgetName);
        } else {
          let rowOptAuth = record.optAuth || optAuth;
          enable = this.getOptAuth(rowOptAuth, widgetName);
        }

        if (header.subform) {
          if (!record.hasOwnProperty(header.subform + "-row-index")) {
            return <></>;
          }
        }
        let hasEditBtn =
          this.props.ignoreOptAuth ||
          (record.dataPerms
            ? record.dataPerms.update || record.dataPerms.flow_update
            : this.props.itemEditable);
        if (!hasEditBtn) {
          enable = false;
        }

        // let ref = React.createRef();
        return (
          <div className="cell-btn">
            <BsyButton
              mode={window.mode + " blue "}
              background={header.background}
              enable={enable}
              style={style}
              theme={witem ? witem.widget && witem.widget.theme : header.theme}
              // onMouseEnter={e => {
              //   if (enable && header.background) {
              //     e.target.style.backgroundColor = header.background.color + "DD";
              //     e.target.style.color = "#fff"
              //   }
              // }}
              // onMouseLeave={e => {
              //   if (enable && header.background) {
              //     e.target.style.backgroundColor = header.background.color;
              //     e.target.style.color = "#fff"
              //   }
              // }}
              text={header.btnText || header.text || header.title}
              click={(e) => {
                e.stopPropagation();
                let event = e;
                if (!enable) {
                  return;
                }

                if (!quickEdit) {
                  return;
                }

                let editEl = BsyUtils.closestClass(
                  e.currentTarget,
                  "art-table-cell"
                ).querySelector(".content-edit");

                let ref = BsyUtils.closestClass(
                  e.currentTarget,
                  "art-table-cell"
                );
                editEl.style.zIndex = 1;
                editEl.style.display = "";
                editEl.style.backgroundColor = "#fff";

                this.dataManager.getRowData(ref, record, (form) => {
                  editEl.style.zIndex = 0;
                  editEl.style.display = "none";
                  editEl.style.backgroundColor = "";
                  let subrowIndex = -1;
                  if (header.subform) {
                    //子表单的单行编辑
                    subrowIndex = record[header.subform + "-row-index"];
                  }

                  form.form.buttonEvent(widgetName, subrowIndex, event);
                });
              }}
            ></BsyButton>
            <div
              className="content-edit"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "none",
              }}
            >
              <BsySLoading customCls={"small"} />
            </div>
          </div>
        );
      }

      default: {
        return (
          <div title={value} className={"table-text"}>
            {value}
          </div>
        );
      }
    }
  };

  //子表单合并的处理
  autoRowSpan = (v1, v2, row1, row2) => {
    // console.log(v1, v2);

    return row1._id === row2._id;
  };

  getSort = (data) => {
    if (data.subform) {
      return { sortable: false };
    }
    //序号
    if (data.tag === "f_row_order" || data.tag === "f_row_menu") {
      return { sortable: false, autoRowSpan: this.autoRowSpan };
    }

    if (this.state.sortIncludedField.indexOf(data.type) > -1) {
      return { sortable: true, autoRowSpan: this.autoRowSpan };
    }
    return { sortable: false, autoRowSpan: this.autoRowSpan };
  };

  transformDataSourceRow = (header, data) => {
    if (!header) return data;

    switch (header.type) {
      case "image":
      case "signature":
      case "upload":
      case "usergroup":
      case "deptgroup":
      case "user":
      case "dept":
      case "assist_flowid":
      case "assist_prostatus":
      case "address":
      case "location":
        // {
        //     return BsyUtils.address2Str(data, header.format || 'pcda')
        //   }
        return CircularJSON.stringify(data);
      case "linkdata": {
        if (data) {
          if (data.linkType) {
            if (data.linkType === "number") {
              let d = data ? data.key : "";
              let res = BsyUtils.numberFormatValue(d, header);
              const afterSuffixVal = getAfterSuffix(header.afterSuffix)
              if (afterSuffixVal && res.text && !res.text.includes("%")) {
                  res.text =  res.text + ' ' + afterSuffixVal;
              } 
              return res.text;
            } else if (data.linkType === "datetime") {
              if (data && data.key) {
                return BsyUtils.date2Str(dayjsUtils.timeToTZ(data.key), "yyyy-MM-dd");
              }
            }
            return data.key;
          }

          if (header.linkType === "number") {
            let d = data ? data.key : "";
            let res = BsyUtils.numberFormatValue(d, header);
            const afterSuffixVal = getAfterSuffix(header.afterSuffix)
            if (afterSuffixVal && res.text && !res.text.includes("%")) {
                res.text =  res.text + ' ' + afterSuffixVal;
            } 
            return res.text;
          } else if (header.linkType === "datetime") {
            if (data && data.key) {
              if (data.key.indexOf("T") > -1 && data.key.indexOf("Z") > -1) {
                return BsyUtils.date2Str(dayjsUtils.timeToTZ(data.key), "yyyy-MM-dd");
              }
            }
          }
        }

        return data ? data.key : "";
      }
      case "datetime":
        // if (data)
        //   return BsyUtils.date2Str(new Date(data), header.format)
        return data;
      case "number":
      case "formula":
        if (data) {
          // let res = {
          //   value: '',
          //   text: '',
          // }
          // if (['assist_protime', 'assist_outtime'].includes(header.name)) {
          //   res = BsyUtils.numberFormatTime(data, header)
          // } else {
          //   res = BsyUtils.numberFormatValue(data, header)
          // }
          return data;
        }

        // return BsyUtils.num2Str(BsyUtils.fixDecimalPrecision(data), header.format)
        return {
          value: "",
          text: "",
        };

      case "flowstate":
      case "flowState": {
        return data; //BsyUtils._getFlowState(data);
      }
      case "checkboxgroup":
      case "combocheck":
      case "array":
        return data;
      case "chargers":
        let m = {},
          n = {};
        BsyUtils.forEach(data, function (a, b) {
          if (b.flowName) {
            m[b.flowName] || (m[b.flowName] = !0);
            n[b.userNickname] || (n[b.userNickname] = !0);
          }
        });

        let outdata = {
          currentnode: [],
          currentcharger: [],
        };
        BsyUtils.forEach(m, function (a) {
          outdata.currentnode.push(a);
        });
        BsyUtils.forEach(n, function (a) {
          outdata.currentcharger.push(a);
        });
        return outdata;
      default:
        return data;
    }
  };

  //处理表单模式
  transformDataSourceSubformRow = (rowData, header, index, rowindexObj) => {
    let datas = [];
    let n = header.length;
    let subformRow = 1;
    let subformFirstRow = rowindexObj.index; //子表单的开始行号
    //先获取 子表单占的最高多少行
    this.subofrmMap.map((data, index) => {
      let celldata = rowData[data.tag || data.name];
      if (celldata) {
        subformRow =
          celldata.length > subformRow ? celldata.length : subformRow;
      }
      return data;
    });

    for (let j = 0; j < subformRow; j++) {
      //处理普通数据
      let data = { ...rowData };
      data.dataIndex = index;
      data.originalrow = rowindexObj.index;
      data.subformFirstRow = subformFirstRow;
      data.subformRowSpan = subformRow;
      for (let i = 0; i < n; i++) {
        let info = header[i];
        if (info.detailOnly) {
          continue;
        }
        let tag = info.tag || info.name;
        let celldata = rowData[tag];
        if (celldata === undefined) {
          data[tag] = undefined;
          continue;
        }

        if (info && info.type === "chargers") {
          let rowData = this.transformDataSourceRow(info, celldata);
          data[tag + "currentnode"] = rowData["currentnode"].join(",");
          data[tag + "currentcharger"] = rowData["currentcharger"].join(",");
        } else if (info && info.type === "subform") {
          let items = info.items;
          let subn = items.length;

          if (celldata[j]) {
            data[tag + "-row-index"] = j; //子表单数据所在行
            if (celldata[j].id) data[tag + "-row-rid"] = celldata[j].id;
          }

          for (let subi = 0; subi < subn; subi++) {
            let subtag = [tag, items[subi].name].join(".");
            if (rowData[tag]) {
              if (rowData[tag][j]) {
                data[subtag] = this.transformDataSourceRow(
                  items[subi],
                  rowData[tag][j][items[subi].name]
                );
              } else {
                data[subtag] = "";
              }
            } else {
              data[subtag] = "";
            }
          }
        } else {
          data[tag] = this.transformDataSourceRow(info, celldata);
        }
      }
      rowindexObj.index++;
      datas.push({ ...data });
    }
    return datas;
  };

  transformDataSource = (args, header) => {
    let hasSubform = this.subofrmMap.length ? true : false;
    let n = header.length;
    let dataSource = [];
    this.AllData = [...args]; //记录当前原始数据，用于查看数据的时候使用
    let rowindexObj = { index: 0 }; //用于记录table数据每位的位置
    args.map((row, index) => {
      row.isCheck = "";

      if (hasSubform) {
        const subformdata = this.transformDataSourceSubformRow(
          row,
          header,
          index,
          rowindexObj
        );
        dataSource = [...dataSource, ...subformdata];
        return row;
      }

      //处理普通数据
      let data = { ...row };
      data.dataIndex = index;
      //记录，实际行号，为后面合并单元格使用
      data.originalrow = rowindexObj.index;
      for (let i = 0; i < n; i++) {
        let info = header[i];
        if (info.detailOnly) {
          continue;
        }
        let tag = info.tag || info.name;

        if (info.type === "menu") {
          data[tag] = null;
          continue;
        }

        let celldata = row[tag];
        if (celldata === undefined) {
          data[tag] = undefined;
          continue;
        }

        if (info && info.type == "chargers") {
          let rowData = this.transformDataSourceRow(info, celldata);
          data[tag + "currentnode"] = rowData["currentnode"].join(",");
          data[tag + "currentcharger"] = rowData["currentcharger"].join(",");
        } else {
          data[tag] = this.transformDataSourceRow(info, celldata);
        }
      }
      // console.log(data)
      dataSource.push({ ...data });
      rowindexObj.index++;
      return row;
    });

    return [...dataSource];
  };

  skipChange = (e) => {
    // console.log('skipChange', e)
    this.setState(
      {
        skip: e,
        loadMode: "goPage",
      },
      () => {
        this.loadData();
      }
    );
  };

  listLimitChange = (e) => {
    // console.log('listLimitChange', e)
    this.setState(
      {
        skip: 0,
        limit: e,
        loadMode: "goPage",
      },
      () => {
        this._updateStoreValue("datatablelimit", e);
        this.loadData();
      }
    );
  };

  //同步默认显示规则
  getPipelinedefaultSort = (sort) => {
    if (!Array.isArray(sort)) return [];
    const sorts = sort.map((data) => {
      let obj = {};
      for (let da in data) {
        obj["code"] = da;
        obj["order"] =
          data[da] == 0
            ? "none"
            : data[da] == 1
              ? "asc"
              : data[da] == -1
                ? "desc"
                : "none";
      }
      return obj;
    });
    // console.log(sorts)
    return sorts;
  };

  getFilterData = (t, mode) => {
    let e = this.props,
      i1 = BsyUtils.applyFunc(this, e.onDataFilter, [], !1),
      a = [];
    if (e.mode == "edit") {
      i1 = {};
      i1.rel = e.filter.rel;
      i1.filter = e.filter.cond;
      console.log(1);
    }

    if (mode == "dataloadwidget") {
      return i1.widgetFilter;
    }
    let i = i1.filter;
    this.filterMap = i1.filterMap;
    return (
      i && (a = a.concat(i)),
      BsyUtils.isObjectEmpty(t) || (a = a.concat(t)),
      e.filter && "visit" !== e.mode && (a = a.concat(e.filter.cond)),
      BsyUtils.isObjectEmpty(a)
        ? {}
        : {
          cond: a,
          rel: i1.rel || BsyConfig().CONST.FILTER_RELATION.AND,
        }
    );
  };

  componentDidUpdate() {
    // console.log('渲染完成')

    // let height = this.element.current.querySelector('.chart-data-border').offsetHeight;
    // let headerHeight = this.element.current.querySelector('.art-table-header').offsetHeight;

    // let body = this.element.current.querySelector('.art-table-body');
    // if (body) {
    //   body.style.height = (height - headerHeight -2) + 'px';
    // }
    this.element.current.querySelector(".art-table-body") &&
      this.element.current
        .querySelector(".art-table-body")
        .setAttribute("data-empty", React.language("data.empty"));
  }

  onClickSort = (column) => {
    let { sort } = this.state;

    let nextState = (state) => {
      if (column.widgetType === "user" || column.widgetType === "dept") {
        if (state === 0) {
          return -1;
        } else if (state === -1) {
          return 0;
        } else {
          return -1;
        }
      } else {
        if (state === 0) {
          return 1;
        } else if (state === 1) {
          return -1;
        } else if (state === -1) {
          return 0;
        } else {
          return 1;
        }
      }
    };

    let name = column.code;
    let newsort = [];
    if (this.sortMap[name]) {
      let state = nextState(this.sortMap[name]);
      if (state === 0) {
        delete this.sortMap[name];
        BsyUtils.forEach(sort, (k, v) => {
          let widget = null;
          BsyUtils.forEach(v, (k1) => {
            widget = k1;
          });
          if (widget !== name) {
            newsort.push({ ...v });
          }
        });
      } else {
        this.sortMap[name] = state;
        BsyUtils.forEach(sort, (k, v) => {
          let widget = null;
          BsyUtils.forEach(v, (k1) => {
            widget = k1;
          });
          if (widget === name) {
            newsort.push({
              [widget]: state,
            });
          } else {
            newsort.push({ ...v });
          }
        });
      }
    } else {
      newsort = [...sort];
      let state = nextState(this.sortMap[name]);
      this.sortMap[name] = state;
      newsort.push({
        [name]: state,
      });
    }
    console.log("-------------onClickSort---------------");
    console.log(sort);
    console.log(newsort);
    this.setState(
      {
        sort: newsort,
        skip: 0,
      },
      () => {
        this.loadData();
      }
    );
  };

  //处理数据
  pipeline = () => {
    if (this.element.current) {
      let atb = this.element.current.querySelector(".art-sticky-scroll");
      if (atb) {
        atb.removeEventListener("scroll", this.onscroll);
        atb.addEventListener("scroll", this.onscroll, false);
      }
    }

    // const { dataSource, columns, sort, isCheckAll } = this.state;
    const { dataSource, columns, sort, isCheckAll, checkStatus } = this.state;
    const pipeline = new TablePipeline({
      ctx: { components: { Checkbox: BsyCheckBox } },
      state: this.state.pipelineState,
      setState: this.setPipelineState,
    });
    function appendId(value) {
      if (Array.isArray(value)) {
        return value.map((i, key) => {
          if (Reflect.has(i, "_id")) {
            return i;
          }
          return {
            ...i,
            _id: String(key),
          };
        });
      }
      return value;
    }

    let fiexlData = CircularJSON.stringify(appendId(dataSource));
    //根据实际情况更新缓存数据 防止数据还原
    if (this.hasCachedData) {
      fiexlData = CircularJSON.stringify(appendId(this.newDataSource));
    }

    pipeline.input({
      dataSource: fiexlData ? CircularJSON.parse(fiexlData) : [],
      columns,
    });
    pipeline.primaryKey("originalrow"); //每一行数据由 id 字段唯一标记

    //对齐处理
    const allColumn = pipeline.getColumns();
    const newColumn = allColumn.map((col) => {
      // console.log('col', col)
      let newCol = { ...col };

      if (newCol.code === "isCheck") {
        newCol.name = (
          <>
            {checkStatus == "check" ? (
              <BsyCheckBox
                key={this.tableKey}
                value={isCheckAll}
                getContext={(e) => {
                  this.AllCheckContext = e;
                }}
                onChange={(e) => {
                  this.onMultiSelect(e, "all");
                }}
              />
            ) : (
              ""
            )}
          </>
        );
      } else {
        // if (col.widgetType === 'number' && col.align == '') {
        //   newCol.align = 'right';
        // }
      }
      return newCol;
    });
    pipeline.columns(newColumn);

    //排序
    pipeline.use(
      features.sort({
        keepDataSource: true,
        mode: "multiple",
        orders: ["asc", "desc", "none"],
        defaultSorts: this.getPipelinedefaultSort(sort),
        //自定义排序表头
        SortHeaderCell: ({
          children,
          column,
          onToggle,
          sortOrder,
          clickArea,
        }) => {
          const justifyContent =
            column.align === "right"
              ? "flex-end"
              : column.align === "center"
                ? "center"
                : "flex-start";
          let name = column.code;
          if (this.sortMap[name]) {
            sortOrder = this.getSortState(this.sortMap[name]);
          }

          return (
            <div
              onClick={
                clickArea === "content"
                  ? () => {
                    // console.log(1111)
                    this.onClickSort(column);
                  }
                  : undefined
              }
              className={"cell-sort-header"}
              style={{
                justifyContent,
                cursor: clickArea === "content" ? "pointer" : undefined,
                display: "flex",
                alignItems: "center",
                paddingRight: 10,
              }}
            >
              {children}{" "}
              {column.widgetType === "user" || column.widgetType === "dept" ? (
                <DeptUserSortIcon
                  onClick={clickArea === "icon" ? onToggle : undefined}
                  style={{
                    userSelect: "none",
                    marginLeft: 2,
                    flexShrink: 0,
                    cursor: clickArea === "icon" ? "pointer" : undefined,
                  }}
                  size={16}
                  order={sortOrder}
                />
              ) : (
                <SortIcon
                  onClick={clickArea === "icon" ? onToggle : undefined}
                  style={{
                    userSelect: "none",
                    marginLeft: 2,
                    flexShrink: 0,
                    cursor: clickArea === "icon" ? "pointer" : undefined,
                  }}
                  size={16}
                  order={sortOrder}
                />
              )}
            </div>
          );
        },
      })
    );
    //列之间拖动
    pipeline.use(
      features.columnResize({
        defaultSizes: this.lastcolumnResize,
        /** 受控用法：列宽数组 */
        sizes: this.lastcolumnResize,
        onChangeSizes: () => {
          // console.log('onChangeSizes', size)
          let resize = this.element.current.querySelector(
            ".column-resizer-line"
          );
          if (resize) {
            resize.style.display = "none";
          }

          setTimeout(() => {
            //做1个像素偏移，防止头部错位，取巧的解决方式，具体原因找不到
            let scroll =
              this.element.current.querySelector(".art-sticky-scroll");
            let scrollLeft = scroll.scrollLeft;
            // console.log('scrollLeft', scrollLeft);
            scroll.scrollLeft = scrollLeft + (scrollLeft > 0 ? -1 : 1);
            scroll.scrollLeft = scrollLeft;
          }, 10);
        },
        onChnageSizePos: (sizes, pos) => {
          // console.log('onChnageSizePos', sizes)
          // console.log(sizes.slice(0, pos + 1))
          this.lastcolumnResize = [...sizes];
          this._updateColSize([...sizes]);

          let sumValue = sizes.slice(0, pos + 1).reduce(function (sum, number) {
            //sum2 前两个数的和

            return sum + number;
          }, 0);

          let scrollLeft =
            this.element.current.querySelector(".art-sticky-scroll").scrollLeft;
          let resizer = this.element.current.querySelector(
            ".column-resizer-line"
          );
          if (resizer) {
            resizer.style.display = "block";
            resizer.style.left = sumValue - scrollLeft - 3 + "px";
          }
        },
        fallbackSize: 100,
        minSize: 50,
        handleBackground: "#ddd",
        handleHoverBackground: "#aaa",
        handleActiveBackground: "#89bff7",
      })
    );

    //多行合并
    pipeline.use(features.autoRowSpan());

    return pipeline.getProps();
  };

  _parseFieldLabelFormat = (e, orgds) => {
    function findField(name) {
      let tag = {};
      BsyUtils.forEach(orgds, (index, data) => {
        if (data.widget.widgetName === name) {
          tag = { ...data.widget };
        }
      });
      return tag;
    }

    let i = [];
    BsyUtils.forEach(e, (e, a1) => {
      let n = {};
      if (!orgds) {
        n = { ...a1 };
      } else {
        if (a1.type === "linkquery") {
          n = { ...a1, ...findField(a1.name) };
        } else {
          n = { ...a1 };
        }
      }
      if (
        (BsyUtils.isNull(n.text) && (n.text = a1.title), "subform" === a1.type)
      ) {
        let s = [];
        BsyUtils.forEach(a1.items, function (e, i) {
          let a = { ...i };
          BsyUtils.isNull(a.text) && (a.text = i.title);
          s.push(a);
        });
        n.items = s;
      }
      i.push(n);
    });
    return i;
  };

  rowHoverEnter = (dataIndex) => {
    const { widgetId } = this.state;
    // console.log('rowHoverEnter')
    this.hoverDataIndex = dataIndex;
    let dd = document.querySelectorAll(
      "#" + widgetId + " .data-index-" + dataIndex + ":not(.hover)"
    );
    let n = dd.length;
    // console.log(dd)
    for (let i = 0; i < n; i++) {
      dd[i].classList.add("hover");
    }
  };

  rowHoverLeave = (dataIndex) => {
    // console.log('rowHoverLeave')
    const { widgetId } = this.state;

    this.hoverDataIndex = null;
    let dd = document.querySelectorAll(
      "#" + widgetId + " .data-index-" + dataIndex
    );
    let n = dd.length;
    // console.log(dd)
    for (let i = 0; i < n; i++) {
      dd[i].classList.remove("hover");
    }
  };

  errorTip = () => {
    const { error, title } = this.state;
    switch (error) {
      case 1: {
        return (
          <div className="empty-wrapper">
            <i className="icon-widget-datatable"></i>
            <div className="empty-text">
              {title + React.language("not.configured")}
            </div>
          </div>
        );
      }
      default:
        return "";
    }
  };

  showLoading = () => {
    const { isLoading } = this.state;
    if (!this.isDashFull) {
      //非自动刷新模式下
      return isLoading ? (
        <BsySLoading key={"table-page-2"} mode={"skeletonspin"} />
      ) : (
        ""
      );
    }
    if (
      !(
        this.props.autoRefresh &&
        this.props.autoRefresh &&
        this.props.autoRefresh.enabled
      )
    ) {
      //非自动刷新模式下
      return isLoading ? (
        <BsySLoading key={"table-page-3"} mode={"skeletonspin"} />
      ) : (
        ""
      );
    }
    return "";
  };

  hasXScroll = () => {
    if (this.element.current) {
      const stickyScroll =
        this.element.current.querySelector(".art-sticky-scroll");
      let height = 0;
      if (stickyScroll && stickyScroll.style) {
        if (stickyScroll.style.display === "none") {
          stickyScroll.style.display = "block";
          height = stickyScroll.offsetHeight;
          stickyScroll.style.display = "none";
        } else {
          height = stickyScroll.offsetHeight;
        }
        if (height > 1) {
          this.element.current
            .querySelector(".chart-data-border")
            .classList.remove("not-x-scroll");
        } else {
          this.element.current
            .querySelector(".chart-data-border")
            .classList.add("not-x-scroll");
        }
      }
      // hide-last-row
      let s = 0;
      let h = 0;
      if (this.element.current.querySelector(".chart-data-border")) {
        s =
          this.element.current.querySelector(".chart-data-border").scrollHeight;

        h =
          this.element.current.querySelector(".chart-data-border").offsetHeight;
        if (s <= h) {
          this.element.current
            .querySelector(".chart-data-border")
            .classList.remove("hide-last-row");
        } else {
          this.element.current
            .querySelector(".chart-data-border")
            .classList.add("hide-last-row");
        }
      }
    }
  };

  render() {
    const {
      count,
      limit,
      skip,
      widgetId,
      level2Menu,
      dataEmpty,
      hasAutoHeight,
      autoHeight,
      useVirtual,
      tablekey,
      dataSource,
      saveMultiPageData,
    } = this.state;
    const { multipleChoice } = this.props;
    let cssname = `chart-data-border ${dataSource && dataSource.length === 0 ? "table-empty" : ""
      } `;
    return (
      <div
        className={
          "data-table " +
          this.platform +
          " " +
          (level2Menu || multipleChoice ? "multiple" : "") +
          " " +
          (hasAutoHeight ? "bsy-row-height-" + autoHeight : "")
        }
        id={widgetId}
        ref={this.element}
        key={tablekey}
      >
        {dataEmpty ? (
          <div className={"chart-data-empty"}>
            <div>
              <i
                className={BsyUtils._getWidgetTypeIcon(this.state.chartType)}
              ></i>
              <span>{React.language("widget.linkdata.empty")}</span>
            </div>
          </div>
        ) : (
          <>
            <div
              className={cssname}
              style={{
                overflowX: "hidden",
                overflowY: "auto",
                height: "calc( 100% - 40px )",
              }}
            >
              <BaseTable
                ref={this.tableRef}
                stickyMode={"css"}
                useVirtual={useVirtual ? { vertical: 30 } : false} //虚拟行开关
                useOuterBorder={false}
                // virtualDebugLabel={'datatable'}
                components={{
                  EmptyContent: () => {
                    return (
                      <tr
                        className="art-table-row first last no-hover"
                        data-rowindex="0"
                      >
                        <td
                          className="art-table-cell first last"
                          colSpan="6"
                          style={{ height: 200 }}
                        >
                          <div className="art-empty-wrapper">
                            <tr></tr>{" "}
                          </div>
                        </td>
                      </tr>
                    );
                  },
                  Row: ({ row, trProps }) => {
                    // console.log('------------Row------------' + new Date().getTime())
                    // console.log(row, rowIndex, trProps)

                    let className = trProps.className;
                    className +=
                      "  data-index-" +
                      row.dataIndex +
                      " row" +
                      row._id +
                      " row-id-" +
                      row._id +
                      " ";
                    className = className.replace("odd", "");
                    className = className.replace("even", "");
                    if (row.dataIndex % 2 === 0) {
                      className += "even";
                    } else {
                      className += "odd";
                    }
                    trProps.dataid = row._id;

                    return (
                      <tr
                        {...trProps}
                        onClick={(e) => {
                          this.cleanCurrentTime();
                          if (!this.props.hasRowClick) {
                            return;
                          }

                          if (
                            !this.props.readData &&
                            (this.props.widgetId === "datatable" ||
                              this.props.widgetId === "linkdatadatatable" ||
                              this.props.widgetId.indexOf("datatableDataLoad") >
                              -1)
                          ) {
                            this.onMultiSelect(
                              this.selectDataId
                                ? !this.selectDataId.includes(row._id)
                                : false,
                              row._id
                            );
                            return;
                          }

                          // 公开查询
                          // if (this.props.widgetId == 'datatable') {
                          //   return;
                          // }

                          // console.log('tr onClick ', e)

                          //忽略菜单 点到单元格的问题
                          if (
                            BsyUtils.closestClass(e.target, "right-cell-menu")
                          ) {
                            return;
                          }
                          //忽略多选的时候 点到单元格的问题
                          if (BsyUtils.closestClass(e.target, "cell-check")) {
                            return;
                          }

                          //有选择当前行内容  不弹出行的数据
                          if (!BsyUtils.isEmpty(BsyUtils.getSelectionText()))
                            return;

                          this.doShowData(row.dataIndex, null, null, true);
                        }}
                        onMouseEnter={(e) => {
                          this.rowHoverEnter(row.dataIndex);

                          // verify-error-info
                          let tip =
                            e.currentTarget.getAttribute("verify-error-info");
                          if (tip && window.FX && window.FX.UI) {
                            //有复选的时候才提示
                            if (e.currentTarget.querySelector(".BsyCheckBox")) {
                              let dd = document.querySelectorAll(
                                "#" +
                                widgetId +
                                " .art-table-sticky-row-header  .data-index-" +
                                row.dataIndex
                              );
                              window.FX.UI.showPopover({
                                position: "top",
                                anchor: window.$(dd.length > 0 ? dd : e.target),
                                content: window
                                  .$(
                                    '<span style="color:#F5222D;font-size:12px"/>'
                                  )
                                  .text(tip),
                                // type: "dark"
                              });
                            }
                          }
                          // console.log('onMouseEnter '+row.dataIndex)
                        }}
                        onMouseMove={(e) => {
                          this.rowHoverEnter(row.dataIndex);

                          // console.log('onMouseEnter '+row.dataIndex)
                        }}
                        // onWheel={e => {
                        //   console.log('onWheel '+row.dataIndex)
                        //   this.rowHoverEnter(row.dataIndex)
                        // }}
                        onMouseLeave={(e) => {
                          this.rowHoverLeave(row.dataIndex);
                          let tip =
                            e.currentTarget.getAttribute("verify-error-info");
                          if (tip && window.FX && window.FX.UI) {
                            window.FX.UI.closePopover();
                          }
                          // console.log('onMouseLeave '+row.dataIndex)
                        }}
                        dataindex={row.dataIndex}
                        originalrow={row.originalrow}
                        className={className}
                      />
                    );
                  },
                  Cell: ({ row, column, tdProps }) => {
                    let s = [];
                    if (column.colorText) {
                      this.getColorFilterConfig(column.orgField);
                      s = this._check_data_bkcolor(row);
                    }
                    if (column.code === "f_row_menu") {
                      tdProps.className =
                        tdProps.className + " right-cell-menu";
                    }
                    if (column.code === "f_row_order") {
                      tdProps.className = tdProps.className + " left-cell-menu";
                    }
                    if (column.code === "isCheck") {
                      tdProps.className = tdProps.className + " cell-check";
                    }

                    if (column.alignment) {
                      tdProps.className =
                        tdProps.className + " " + column.alignment;
                    }

                    if (column.orgField) {
                      //定位控件位置
                      let widgetName = this.getWidgetName(column.orgField);
                      if (widgetName) {
                        tdProps.className =
                          tdProps.className +
                          " " +
                          widgetName.replace(".", "-");

                        if (column.orgField.subform) {
                          //定位子表单控件的位置
                          tdProps.className =
                            tdProps.className +
                            " " +
                            (column.widgetType || column.orgField.widget.type);
                          if (
                            row.hasOwnProperty(
                              column.orgField.subform + "-row-index"
                            )
                          ) {
                            tdProps.subformrow =
                              row[column.orgField.subform + "-row-index"];
                            tdProps.className =
                              tdProps.className +
                              " " +
                              widgetName.replace(".", "-") +
                              "-subrow-" +
                              row[column.orgField.subform + "-row-index"];
                            var db = row[column.orgField.subform + "-row-rid"];
                            tdProps.className += ` F${db}`;
                          }
                        } else {
                          tdProps.className =
                            tdProps.className + " " + column.widgetType;
                        }
                      }
                    }

                    if (column.customCls) {
                      tdProps.className =
                        tdProps.className + " " + column.customCls;
                    }
                    return (
                      <td
                        {...tdProps}
                        onMouseOver={(event) => {
                          // event.stopPropagation();

                          var td = BsyUtils.closestClass(
                            event.currentTarget,
                            "art-table-cell"
                          );
                          if (!td) {
                            return;
                          }
                          let tip = td.getAttribute("data-error-tip");
                          if (tip && window.FX && window.FX.UI) {
                            window.FX.UI.showPopover({
                              // position: "topLeft",
                              anchor: window.$(event.currentTarget),
                              content: window
                                .$(
                                  '<span style="color:#F5222D;font-size:12px" />'
                                )
                                .html(tip),
                              // type: "dark"
                            });
                          }
                        }}
                        onMouseOut={(event) => {
                          var td = BsyUtils.closestClass(
                            event.currentTarget,
                            "art-table-cell"
                          );
                          if (!td) {
                            return;
                          }
                          let tip = td.getAttribute("data-error-tip");
                          if (tip && window.FX && window.FX.UI) {
                            window.FX.UI.closePopover();
                          }
                        }}
                        ref={(node) => {
                          //兼容 important的写法，是否会产生效率问题？？？ 2022 03 12 bobo
                          if (node) {
                            // 处理条件颜色
                            if (row.background) {
                              node.style.setProperty(
                                "background",
                                row.background,
                                "important"
                              );
                            }
                            if (row.color) {
                              node.style.setProperty(
                                "color",
                                row.color,
                                "important"
                              );
                            }
                            if (s.length) {
                              node.style.setProperty(
                                "color",
                                "rgb(" + s[1] + ")",
                                "important"
                              );
                            }
                          }
                        }}
                      />
                    );
                  },
                }}
                {...this.pipeline()}
              />
            </div>
            <div className="page">
              {hasAutoHeight && (
                <div
                  className={"bsy-row-height-combo " + autoHeight}
                  onClick={(event) => {
                    // height: "Height",
                    // middle: "Middle",
                    // low: "Low",

                    let menus = [
                      {
                        text: React.language("height1"),
                        icon: "icon-bsy-height",
                        customCls: autoHeight === "height" ? "select" : "",
                        click: () => {
                          this.setState(
                            {
                              autoHeight: "height",
                            },
                            () => {
                              this._updateStoreValue(
                                "autoHeight",
                                this.state.autoHeight
                              );
                            }
                          );
                        },
                      },
                      {
                        text: React.language("middle"),
                        icon: "icon-bsy-middle",
                        customCls: autoHeight === "middle" ? "select" : "",
                        click: () => {
                          this.setState(
                            {
                              autoHeight: "middle",
                            },
                            () => {
                              this._updateStoreValue(
                                "autoHeight",
                                this.state.autoHeight
                              );
                            }
                          );
                        },
                      },
                      {
                        text: React.language("low"),
                        icon: "icon-bsy-low",
                        customCls: autoHeight === "low" ? "select" : "",
                        click: () => {
                          this.setState(
                            {
                              autoHeight: "low",
                            },
                            () => {
                              this._updateStoreValue(
                                "autoHeight",
                                this.state.autoHeight
                              );
                            }
                          );
                        },
                      },
                      {
                        text: React.language("adaptive"),
                        icon: "icon-bsy-adaptive",
                        customCls: autoHeight === "adaptive" ? "select" : "",
                        click: () => {
                          this.setState(
                            {
                              autoHeight: "adaptive",
                            },
                            () => {
                              this._updateStoreValue(
                                "autoHeight",
                                this.state.autoHeight
                              );
                            }
                          );
                        },
                      },
                    ];

                    BsyAlertMenu({
                      item: menus,
                      width: 180,
                      target: event.currentTarget,
                      theme: this.props.theme,
                      customCls: " data-manage-batch-menu ",
                    });
                  }}
                >
                  <i className={"icon-bsy-" + autoHeight}></i>
                </div>
              )}
              <BsyTurnPage
                getContext={(context) => {
                  this.Turnpage = context;
                }}
                skipChange={this.skipChange}
                listLimitChange={this.listLimitChange}
                limit={limit}
                hasTurnLast={true}
                skip={skip}
                count={count}
                selectDataId={
                  saveMultiPageData
                    ? this.selecteData.map((it) => it._id)
                    : this.selectDataId
                }
                theme={this.props.theme}
              // styleType={styleType}
              />
            </div>
          </>
        )}
        {this.showLoading()}
      </div>
    );
  }

  _isCondItemMatch = (t, e) => {
    const FX = window.FX;
    this.widgetFilterMap = {
      text: TextWidgetFilter,
      number: NumberWidgetFilter,
      formula: NumberWidgetFilter,
      datetime: DatetimeWidgetFilter,
      combocheck: ComboCheckWidgetFilter,
      textarea: TextareaWidgetFilter,
      address: AddressWidgetFilter,
      user: UserWidgetFilter,
      usergroup: UserGroupWidgetFilter,
      dept: DeptWidgetFilter,
      deptgroup: DeptGroupWidgetFilter,
      signature: SignatureWidgetFilter,
      file_list: FileListWidgetFilter,
      flowState: NumberWidgetFilter,
      flowstate: NumberWidgetFilter,
      flowDecision: NumberWidgetFilter,
      flowdecision: NumberWidgetFilter,
      chargers: UserGroupWidgetFilter,
      radiogroup: TextWidgetFilter,
      checkboxgroup: ComboCheckWidgetFilter,
      combo: TextWidgetFilter,
      image: FileListWidgetFilter,
      upload: FileListWidgetFilter,
    };
    var i = this.widgetFilterMap[t.type];
    return !!i && new i(t).invoke()(e);
  };

  _check_data_bkcolor = (data) => {
    let b = this;
    let i = b.props;
    let res = [];

    if (this.bkColor && this.bkColor.length) {
      //检查数据条件并设置对应的颜色
      let d = data[b.bkColorKey];
      if (typeof d === "string") {
        try {
          d = CircularJSON.parse(d);
          if (typeof d === "number") {
            d = d.toString();
          }
        } catch (e) { }
      }
      if (BsyUtils.isObjectEmpty(d)) {
        if (this.bkColor && this.bkColor.length && b.bgColorFilter) {
          BsyUtils.forEach(this.bkColor, function (index, val) {
            let method = val.method;
            let t = {
              field: b.bgColorFilter.tag,
              id: b.bgColorFilter.id || b.bgColorFilter.form,
              method: method == "formula" ? "eq" : method,
              name: b.bgColorFilter.name,
              type: b.bkColorType,
              value: val.term,
            };
            let dataItem = null;
            let hasDataColor = b._isCondItemMatch(t, dataItem);
            if (hasDataColor) {
              res = [val.color, val.colorText];
            }
          });
        }

        return res;
      }
      BsyUtils.forEach(this.bkColor, function (index, val) {
        let dataItem;
        let value;
        let method = val.method;
        if (val.fixed === "currentUser") {
          value = window.FX.STATIC.user.dock_userid
            ? [window.FX.STATIC.user.dock_userid]
            : [window.FX.STATIC.user._id];
        } else {
          if (
            b.bkColorType === "flowState" ||
            b.bkColorType === "flowstate" ||
            b.bkColorType === "flowDecision" ||
            b.bkColorType === "flowdecision"
          ) {
            value = [val.fixed];
          } else if (
            b.bkColorType === "image" ||
            b.bkColorType === "upload" ||
            b.bkColorType === "signature"
          ) {
            if (val.fixed.indexOf("NotNull") > -1) {
              method = "not_empty";
            } else {
              method = "empty";
            }
          } else if (
            b.bkColorType === "number" ||
            b.bkColorType === "formula"
          ) {
            value = BsyUtils.isArray(val.term[0]) ? val.term[0] : val.term;
            let newVal = [];
            BsyUtils.forEach(value, function (obj, val) {
              newVal.push(isNaN(Number(val)) ? null : Number(val));
            });
            value = newVal;
          } else if (b.bkColorType === "datetime") {
            value = BsyUtils.isArray(val.term[0]) ? val.term[0] : val.term;

            if (val.method == "range") {
              let newVal = [];
              BsyUtils.forEach(val.term, function (obj, val) {
                newVal.push(BsyUtils.date2Str(dayjsUtils.timeToTZ(val), "yyyy-MM-dd"));
              });
              value = newVal;
            } else {
              if (val.fixed !== "fixed") {
                value = [val.fixed];
              } else {
                let newVal = [];
                BsyUtils.forEach(value, function (obj, val) {
                  newVal.push(BsyUtils.date2Str(dayjsUtils.timeToTZ(val), "yyyy-MM-dd"));
                });
                value = newVal;
              }
            }
          } else {
            value = BsyUtils.isArray(val.term[0]) ? val.term[0] : val.term;
          }
        }
        let t = {
          field: b.bgColorFilter.tag,
          id: b.bgColorFilter.id || b.bgColorFilter.form,
          method: method == "formula" ? "eq" : method,
          name: b.bgColorFilter.name,
          type: b.bkColorType,
          value: value,
        };
        if (
          (val.fixed === "currentUser" ||
            (b.bgColorFilter.length && b.bkColorKey === "creator") ||
            b.bkColorType === "user") &&
          b.bkColorType !== "chargers"
        ) {
          dataItem = d && d.id ? d.id : "";
        } else if (b.bkColorType === "usergroup") {
          let usergroup = [];
          BsyUtils.forEach(d, function (obj, val) {
            usergroup.push(
              val.id ? val.id : BsyUtils.isArray(val) ? val : val.id
            );
          });
          dataItem = usergroup;
        } else if (b.bkColorType === "chargers") {
          let usergroup = [];
          BsyUtils.forEach(d, function (obj, val) {
            usergroup.push(
              val.userId
                ? val.userId.indexOf("@") >= 0
                  ? val.userId.split("@")[0]
                  : val.userId
                : !BsyUtils.isArray(val)
                  ? val.userId.indexOf("@") >= 0
                    ? val.userId.split("@")[0]
                    : val.userId
                  : val
            );
          });
          dataItem = usergroup;
        } else if (
          b.bkColorType === "flowState" ||
          b.bkColorType === "flowstate"
        ) {
          let n = BsyConfig().CONST.WORKFLOW.FLOWSTATE,
            r = {};
          r[n.INPROCESS] = React.language("flow.state.inProcess");
          r[n.COMPLETE] = React.language("flow.state.complete");
          r[n.CLOSE] = React.language("flow.state.closed");
          dataItem = d;
        } else if (
          b.bkColorType === "flowdecision" ||
          b.bkColorType === "flowDecision"
        ) {
          dataItem = d === undefined ? null : Number(d.state_id);
        } else if (b.bkColorType === "number" || b.bkColorType === "formula") {
          dataItem = isNaN(Number(d)) ? null : Number(d);
        } else if (b.bkColorType === "datetime") {
          dataItem = d === undefined ? null : d;
          dataItem = BsyUtils.date2Str(dayjsUtils.timeToTZ(dataItem), "yyyy-MM-dd");
        } else {
          dataItem = d === undefined ? null : d;
        }
        let hasDataColor = b._isCondItemMatch(t, dataItem);
        if (hasDataColor) {
          res = [val.color, val.colorText];
        }
      });
    }
    return res;
  };
  //前端颜色对比的时候，数字字段可能出现两种格式的字段类型，所以需要做统一
  val2number = (dataVal) => {
    let v = null;
    if (dataVal) {
      if (dataVal.hasOwnProperty("value")) {
        v = parseFloat(dataVal.value);
      } else {
        v = parseFloat(dataVal);
      }
    } else {
      v = parseFloat(dataVal);
    }
    return v;
  };

  BBY_doSetFields = (t) => {
    let e = this;
    if (!BsyUtils.isNull(e.fields)) {
      let i = BsyUtils.getShowFieldItems(e.fields, this.allFields);
      let value = [];
      BsyUtils.forEach(i, (index, data) => {
        if (data.selected) {
          value.push(data.value);
        }
      });
      BsyMsgBubble({
        anchor: t.target,
        contentHTML: () => {
          return (
            <TriggerComboCheckPane
              items={i}
              hasSelectAll={true}
              value={value}
              onSelect={(val) => {
                // that.selectItem(val)
                e.fields = BsyUtils.getShowFieldsByNames(e.allFields, val);
              }}
              onSeach={this.onSeach}
            />
          );
        },
        text4Cancel: null,
        text4Ok: null,
        theme: this.props.theme,
        minWidth: 150,
        width: 230,
        contentPadding: 0,
        edge: 200,
        hAdjust: 72,
        dockPosition: "left",
        onClose: function () {
          let parentNode = BsyUtils.closestClass(
            e.element.current,
            "bsy_dash_block"
          );
          if (parentNode) {
            parentNode.classList.remove("focus");
          }
          e._updateCachedFields();
          return !1;
        },
      });
    }
  };

  doShowData = (e, type, data, animation, lowLayer) => {
    if (this.props.onShowData) {
      this.props.onShowData(this.AllData[e]);
      return;
    }

    const {
      authGroupId,
      widgetId,
      enableRowEdit,
      quickEdit,
      is_dock_form,
      isBackup,
    } = this.state;
    let that = this;
    this._dataIndex = e;
    let i = data ? data : this.AllData[e];
    this._ = e;
    if (i) {
      let a = this,
        n = this.props,
        o = this.header;
      let layerRef = null;
      let f = i._id;

      let hasCopy = true;
      if (!n.ignoreOptAuth) {
        hasCopy = i.dataPerms ? i.dataPerms.copy : false;
      }

      let hasEditBtn =
        n.ignoreOptAuth || (i.dataPerms ? i.dataPerms.update : n.itemEditable);
      let hasDeleteBtn =
        n.ignoreOptAuth || (i.dataPerms ? i.dataPerms.delete : n.itemRemovable);
      let hasLog =
        n.ignoreOptAuth || (i.dataPerms ? i.dataPerms.log : n.itemLog);
      let hasComment =
        n.ignoreOptAuth || (i.dataPerms ? i.dataPerms.comment : n.itemComment);
      let flow_log =
        (n.hasFlow && n.ignoreOptAuth) ||
        (i.dataPerms ? i.dataPerms.flow_log : n.flow_log);
      let hasFlowBtn = n.hasFlow && (n.ignoreOptAuth || !n.hasRecoverBtn);
      let extDashData = {
        appId: this.props.appId,
        entryId: this.props.entryId,
        formId: this.props.forms[0],
        widgetId: widgetId,
      };

      let d1 = BsyUtils.checkRefApp({
        appId: this.state.appId,
        entryId: this.state.entryId,
        formId: this.state.forms[0],
        dataId: f,
        iseditable: !1,
        fields: this.state.fields,
        formulas: this.state.formulas,
        popupFormPath: a.popupFormPath.concat({
          appId: a.props.appId,
          entryId: a.props.entryId,
          formId: a.props.forms[0],
          widgetId: a.props.widgetId,
        }),
      });
      let entrance = n.entrance || n.origin || this.reftype || "form";
      const { restore } = BsyUtils.globalIdManager(d1.appId, d1.entryId);
      if (
        !n.origin ||
        this.reftype === "etl_table" ||
        this.reftype === "aggregate_table"
      ) {
        let dataUrl = "/data/dataView";

        let needFetchViewData =
          n.origin === "report" || n.isEtlTable || n.recycle ? !1 : !0;

        let onedit = undefined;
        if (n.extDashData) {
          dataUrl = "/data/dash_process_data";
          needFetchViewData = true;
        } else {
          onedit = !n.origin
            ? function (y) {
              that.setState({ optAuth: y.optAuth }, () => { });
            }
            : null;
        }

        let config = {
          dataUrl: dataUrl,
          appId: d1.appId,
          entryId: d1.entryId,
          formId: d1.formId,
          origin: n.origin,
          entrance: entrance,
          originPrint: n.originPrint,
          items: n.formItems || [],
          ignoreOptAuth: n.ignoreOptAuth,
          ignoreAuth: n.ignoreAuth,
          ignoreValidate: n.ignoreValidate,
          ignoreVisible: n.ignoreAuth,
          is_dock_form: is_dock_form,
          needFetchViewData: needFetchViewData,
          hasShowFieldsBtn: n.hasShowFieldsBtn || n.needFetchViewData,
          widgetId: this.state.widgetId,
          hasFlowLog: flow_log,
          hasLogView: false,
          hasFlowBtn: hasFlowBtn,
          ptlist: [],
          hasShareBtn: !n.origin ? true : false,
          allShowFields: !n.origin ? o : this._parseFieldLabelFormat(o),
          width: "80%",
          forms: this.state.forms,
          header: !n.origin ? o : this._parseFieldLabelFormat(o),
          data: i,
          multiTabs: null,
          dataId: i._id,
          optAuth: i.optAuth || this.props.optAuth,
          title: n.title,
          isBackup: isBackup,
          height: "100%",
          hasSwitchBtn: !0,
          sourceType: n.type,
          dataIndex: e + 1,
          hasPrintBtn: n.recycle ? !1 : !0,
          hasCustomPrint: !0,
          dataCount: this.AllData.length,
          hasEditBtn: n.recycle ? !1 : hasEditBtn,
          hasDeleteBtn: n.recycle ? !1 : hasDeleteBtn,
          hasRecoverBtn: n.recycle,
          hasLog: hasLog,
          // optAuth: this.props.optAuth,
          hasComment: hasComment,
          enableRowEdit: enableRowEdit,
          quickEdit: quickEdit,
          extDashData: n.extDashData ? n.extDashData : undefined,
          authGroupId: n.origin ? undefined : authGroupId,
          dataPerms: i.dataPerms,
          onRecoverData: n.onRecoverData
            ? function (a, b) {
              BsyUtils.applyFunc(
                that,
                that.props.onRecoverData,
                [
                  a,
                  b,
                  () => {
                    restore();
                    layerRef && layerRef.close();
                  },
                ],
                !1
              );
            }
            : null,

          onCloseFlow: n.onCloseFlow
            ? function () {
              BsyUtils.applyFunc(
                that,
                that.props.onCloseFlow,
                [
                  f,
                  () => {
                    restore();
                    layerRef.close();
                  },
                ],
                !1
              );
            }
            : null,

          // onEditData: onedit,
          onDeleteData: !n.origin
            ? function () {
              BsyAlert({
                // title: React.language("api.deleteData"),
                title: React.language("del.data.tip"),
                type: "error",
                text4Ok: React.language("ok"),
                text4Cancel: React.language("cancel"),
                OkType: "red",
                ok: function () {
                  that.BBY_doDeleteData([f]);
                  restore();
                  layerRef.close();
                },
              });
            }
            : null,
          onSwitchData: function (t) {
            that.doShowData(t - 1, null, null, false, layerRef);
          },
        };

        BsyMaskLayer({
          customCls: animation ? "fadein-right" : "",
          onMaskClick: (event) => {
            // if (event.target.classList.contains("BsyMaskLayer")) {
            //   layerRef.close();
            // }
          },
          onContentCreate: (ref) => {
            layerRef = ref;

            return (
              <BsyFormPane
                {...config}
                mode={"view"}
                onClose={(status, reshow) => {
                  restore();
                  layerRef && layerRef.close();
                  if (status) {
                    that.setState(
                      {
                        // skip: this.state,
                      },
                      () => {
                        that.loadWidget();
                      }
                    );
                  }
                }}
              />
            );
          },
        });
        lowLayer && lowLayer.close();
        return;
      }
      if (this.state.widgetId) {
        d1.widgetId = this.state.widgetId;
        d1.appId = this.state.appId;
        d1.entryId = this.state.entryId;
      }
      window.FX.Utils.dataAjax(
        {
          url: "/data/read",
          data: d1,
        },
        function (g) {
          let fieldtabs = {};
          BsyUtils.forEach(g.form.items, function (a1, b1) {
            if (b1.tab) fieldtabs[b1.widget.widgetName] = b1.tab;
          });
          let newdata = {};
          let fields = [];
          let o1 = that._parseFieldLabelFormat(o, g.form.items);
          BsyUtils.forEach(o1, function (a1, b1) {
            let tmpdata = { ...b1 };

            if (["dataload", "button"].indexOf(b1.type) > -1) {
              return !0;
            }
            if (b1.isOrderCol) {
              return !0;
            }

            if (fieldtabs.hasOwnProperty(b1.name)) {
              tmpdata.tab = fieldtabs[b1.name];
            }
            fields.push(tmpdata);
            newdata[b1.tag] = g.data[b1.name];
            newdata[b1.name] = g.data[b1.name];
          });
          newdata = { ...newdata, ...g.data };
          if (g.hasCoop || !g.hasFlow) {
            flow_log = !1;
          }
          if (flow_log) {
            newdata["flowStack"] = g.data["flowStack"];
            newdata["flowState"] = g.data["flowState"];
            newdata["chargers"] = g.data["chargers"];
            newdata["flowVer"] = g.data["flowVer"];
          }
          if (that.props.ptlist || that.props.readData) {
            //外链查询使用
            i.dataPerms.ptlist = that.props.ptlist;
          }
          newdata.optAuth = i.optAuth;

          let config = {
            ...g.form,
            appId: d1.appId,
            refAppId: d1.refAppId,
            entryId: d1.entryId,
            formId: d1.formId,
            items: g.form.items,
            form: g.form,
            entrance: entrance,
            fieldShowRules: that.props.ignoreAuth ? [] : g.form.fieldShowRules,
            subformFieldShowRules: that.props.ignoreAuth
              ? []
              : g.form.subformFieldShowRules,
            origin: n.origin,
            originPrint: n.origin,
            authGroupId: n.origin ? undefined : authGroupId,
            needFetchViewData:
              n.origin === "report" || n.isEtlTable || n.recycle ? !1 : !0,
            hasShowFieldsBtn: n.hasShowFieldsBtn || n.needFetchViewData,
            widgetId: that.state.widgetId,
            hasFlowLog: flow_log,
            hasLogView: flow_log,
            hasFlowBtn: flow_log,
            optAuth: newdata.optAuth,
            is_dock_form: g.is_dock_form,
            ptlist: i.dataPerms && i.dataPerms.ptlist,
            hasShareBtn: !1,
            width: "80%",
            forms: that.state.forms,
            header: fields, //a._parseFieldLabelFormat(o),
            allShowFields: fields,
            data: newdata,
            editValue: newdata,
            sourceType: n.type,
            multiTabs: g.formTabs,
            formTabsStyle: g.formTabsStyle || {},
            dataId: g.data._id,
            rawdata: that.props.rawdata,
            extDashData: that.props.rawdata ? extDashData : null,
            title: that.props.title,
            height: "100%",
            hasSwitchBtn: !0,
            dataIndex: e + 1,
            hasPrintBtn: !0,
            hasCustomPrint: !0,
            dataCount: that.AllData.length,
            hasEditBtn: hasEditBtn,
            hasDeleteBtn: hasDeleteBtn,
            hasCopy: hasCopy,
            hasLog: hasLog,
            dataPerms: i.dataPerms,
            hasComment: hasComment,
            popupFormPath: a.popupFormPath.concat({
              appId: a.props.appId,
              entryId: a.props.entryId,
              formId: a.props.forms[0],
              widgetId: a.props.widgetId,
            }),
          };
          const configEvents = {
            onSwitchData: function (t) {
              that.doShowData(t - 1, null, null, false, layerRef);
            },
            onClose: function (isEdit, reshow) {
              if (isEdit) {
                that.reload({});
              }
              if (reshow) {
                that.doShowData(e, type, data, false, layerRef);
                return;
              }
              restore();
              layerRef.close();
            },
            onCloseFlow: function () { },
            onDeleteData: function () {
              BsyAlert({
                // title: React.language("api.deleteData"),
                title: React.language("del.data.tip"),
                type: "error",
                text4Cancel: React.language("cancel"),
                text4Ok: React.language("ok"),
                OkType: "red",
                ok: function () {
                  that.BBY_doDeleteData([f]);
                  restore();
                  layerRef.close();
                },
              });
            },
          };

          const formConfig = {
            ...g,
            appId: a.state.appId,
            entryId: a.state.entryId,
            formId: a.state.forms[0],
            originPrint: n.origin,
            dataId: f,
            content: config,
          };

          BsyMaskLayer({
            customCls: animation ? "fadein-right" : "",
            onMaskClick: (event) => {
              // if (event.target.classList.contains("BsyMaskLayer")) {
              //   layerRef.close();
              // }
            },
            onContentCreate: (ref) => {
              layerRef = ref;

              return (
                <BsyFormPane
                  {...config}
                  {...configEvents}
                  formConfig={formConfig}
                  mode={"view"}
                />
              );
            },
          });
        },
        function () {
          // t11 && t11.close();
          restore();
          lowLayer && lowLayer.close();
          return !1;
        },
        function () {
          lowLayer && lowLayer.close();
          // t11 && t11.close();
        }
      );
    }
  };

  _isFieldsValid = () => {
    let t = this.props,
      e = !0;
    e &= !window.FX.Utils.isEmpty(t.forms);
    e &= t.fields && t.fields.length > 0;

    return e;
  };

  BBY_doDeleteData = (a, clearAll, filter, extDashData) => {
    let that = this;
    const { origin, authGroupId, ignoreOptAuth } = this.props;

    if (
      !clearAll &&
      BsyUtils.isObjectEmpty(a) &&
      BsyUtils.isObjectEmpty(filter)
    ) {
      tipAlert({
        type: "warning",
        msg: React.language("no.data.selected"),
      });
      return;
    }

    let d = {
      appId: this.state.appId,
      entryId: this.state.entryId,
      formId: this.state.forms[0],
      idList: BsyUtils.isObjectEmpty(a) ? undefined : a,
      clearAll: clearAll
        ? clearAll
        : BsyUtils.isObjectEmpty(filter)
          ? false
          : true,
      filter: clearAll ? {} : !BsyUtils.isObjectEmpty(a) ? {} : filter,
      authGroupId: origin ? undefined : authGroupId,

      jsplatform: ignoreOptAuth || authGroupId !== null ? "React" : undefined,
      extDashData: this.props.extDashData,
      popupFormPath:
        !origin || extDashData
          ? undefined
          : that.popupFormPath.concat({
            appId: that.props.appId,
            entryId: that.props.entryId,
            formId: that.props.forms[0],
            widgetId: that.props.widgetId,
          }),
    };
    d = BsyUtils.checkRefApp(d);

    // this.setState({
    //   isLoading: true
    // }, () => {
    let layerRef = null;
    BsyMaskLayer({
      customCls: "sloading",
      onContentCreate: (ref) => {
        layerRef = ref;
        return (
          <div>
            <BsySLoading />{" "}
          </div>
        );
      },
    });
    React.axios("/data/remove", d)
      .then((res) => {
        layerRef && layerRef.close();
        if (res.data.msg) {
          //给后端_form事件用  返回真的时候有提示信息也要提示 zhxj 19521
          tipAlert({
            type: "success",
            msg: res.data.msg,
          });
          return;
        }
        this.setState(
          {
            skip: 0,
            isLoading: false,
          },
          () => {
            this.loadWidget();
          }
        );
      })
      .catch((res) => {
        console.error(res);
        layerRef && layerRef.close();
        this.setState({
          isLoading: false,
        });
      });
    // })
  };

  BBY_doSort = () => {
    let e = this;
    let i = null;
    let a = new window.FX.ConfirmDialog({
      title: React.language("dash.sort.setting"),
      width: 600,
      text4Ok: React.language("sort"),
      hasSeparator: !0,
      onContentCreate: function (t) {
        i = t;
      },
      onOk: function () {
        e.setState(
          {
            sort: n.getSorts(),
          },
          () => {
            e.loadData();
          }
        );
        a.close();
      },
    });
    a.show();
    let n = new window.FX.DashSortPane({
      renderEl: i,
      fields: this.state.fields,
      sorts: this.state.sort,
    });
  };

  _getCheckData = () => {
    const { saveMultiPageData } = this.state;

    if (saveMultiPageData) {
      return this.selecteData;
    } else {
      let datas = [];
      this.AllData.map((data) => {
        if (this.selectDataId.indexOf(data._id) > -1) {
          datas.push(data);
        }
      });
      return datas;
    }
  };

  create = (res, menu, cb) => {
    let that = this;
    that.popupFormPath = that.popupFormPath || [];
    let _opt = this.props;
    let d1 = {
      formId: _opt.forms[0],
      appId: _opt.appId,
      entryId: _opt.entryId,
      authGroupId: _opt.origin ? null : _opt.authGroupId,
      extDashData: _opt.extDashData,
      popupFormPath: _opt.extDashData
        ? null
        : !_opt.origin
          ? undefined
          : that.popupFormPath.concat({
            appId: _opt.appId,
            entryId: _opt.entryId,
            formId: _opt.forms[0],
            widgetId: _opt.widgetId,
            // menuId: "create",
            // menuType: 'menu',
            menuId: menu.menuId,
            menuType: menu.menuType || "datamenu",
          }),
    };
    d1 = BsyUtils.checkRefApp(d1);

    let gm = null;
    let formConfig = {};
    if (res) {
      let that = this;
      that.isSubmitData = false;
      const h = res ? res.data.entry : {};
      gm = BsyUtils.globalIdManager(h.appId, h.entryId);
      if (!BsyUtils.isObjectEmpty(h.href)) {
        window.FX.STATIC.FORMHREF = h.href;
      } else {
        window.FX.STATIC.FORMHREF = null;
      }

      formConfig = {
        ...h,
        appId: h.appId,
        entryId: h.entryId,
      };
      formConfig.content.width = "80%";
      formConfig.content.name = h.name;
      formConfig.content.designDataId = res.data ? res.data.dataId : "";
      //designDataId: g ? g.dataId : '',
    } else {
      gm = BsyUtils.globalIdManager(d1.appId, d1.entryId);
    }
    that.isSubmitData = false;
    let layerRef = null;
    BsyMaskLayer({
      customCls: "fadein-right",
      onMaskClick: (event) => {
        // if (event.target.classList.contains("BsyMaskLayer")) {
        //   layerRef.close();
        // }
      },
      onContentCreate: (ref) => {
        layerRef = ref;
        return (
          <BsyFormPane
            hasHeader={true}
            width={"80%"}
            {...d1}
            formConfig={formConfig}
            mode={"new"}
            ignoreAuth={_opt.ignoreAuth}
            ignoreOptAuth={_opt.ignoreOptAuth}
            ignoreValidate={_opt.ignoreValidate}
            onClose={(status, data, autoClose) => {
              gm.restore();
              if (status) {
                if (!cb) that.reload({});
                that.isSubmitData = true;
              }

              cb && cb();
              layerRef && layerRef.close();
            }}
          />
        );
      },
    });
  };

  BBY_doExcelExport = () => {
    let i = this.props;
    let that = this;
    if (this._isFieldsValid()) {
      let fields = [];
      BsyUtils.forEach(this.state.fields, function (a1, b1) {
        if (["separator", "button", "dataload"].indexOf(b1.type) == -1) {
          let de = {
            ...b1,
            id: b1.form,
          };
          fields.push(de);
        }
      });

      let config = {
        fields: fields,
        showFields: fields,
        // asyncExportURL: i.asyncExportURL,
        // fields: that._getFields(BsyConfig().LimitFields.excelExport),
        filter: this.getFilterData(this.filterParam),
        time: window.siteDevInfo.sitesetting.export_datatable_max_time,
        limit: window.siteDevInfo.sitesetting.export_datatable_max_num,
        forms: [that.props.forms[0]],
        appId: i.appId,
        entryId: i.entryId,
        widgetId: i.widgetId,
        title: i.title,
        sort: this.state.sort,
        reftype: this.reftype,
        isDataId: false,
        name: [i.dashTitle, i.title].join("-"),
        popupFormPath: that.popupFormPath.concat({
          appId: that.props.appId,
          entryId: that.props.entryId,
          formId: that.props.forms[0],
          widgetId: that.props.widgetId,
        }),
        // showFields: this.componentContext.fields,
      };

      BsyDialog({
        title: React.language("export.excel"),
        height: "auto",
        width: 600,
        noFooter: true,
        onContentCreate: (e) => {
          return (
            <BsyExportPane
              {...config}
              onOk={(PostParam) => {
                window.FX.Msg.notice({
                  title: React.language("export.excel.notice.title"),
                  type: "async",
                  duration: 0,
                  content: React.language("export.excel.notice.content"),
                });
                e.closeAlter();
                React.axios(i.asyncExportURL, PostParam)
                  .then((res) => {
                    if (res.data.url) {
                      let e = window.$("<div />").append(
                        window.$("<p />").text(
                          React.language("export.excel.fileSuccess.content", {
                            name: i.title,
                            time: BsyUtils.convertToRemainingTime(
                              (window.siteDevInfo.sitesetting
                                .export_datatable_max_time || 1440) * 60,
                              "hour"
                            ),
                          })
                        )
                      );
                      e.append(
                        window
                          .$("<a href='javascript:void(0);' />")
                          .text(React.language("download.immediately"))
                          .on("click", function () {
                            BsyUtils.downloadFile2(i.title, res.data.url);
                            return false;
                          })
                      );
                      window.FX.Msg.notice({
                        title: React.language("export.excel.fileSuccess"),
                        type: "success",
                        duration: 0,
                        content: e,
                      });
                    } else {
                      window.FX.Msg.notice({
                        title: React.language("export.failTip"),
                        type: "error",
                        duration: 0,
                        content: res.data.msg,
                      });
                    }
                  })
                  .catch((res) => {
                    console.error(res);
                  });
              }}
              onCancel={() => {
                e.closeAlter();
              }}
            />
          );
        },
      });

      return;
    }
  };
}

export default BsyDataTable;

function SortIcon({ order }) {
  return (
    <div className={"sort-icon " + order}>
      <i className="icon-bsy-iconshangxia" />
      <i className="icon-bsy-sort-asc" />
      <i className="icon-bsy-sort-desc" />
    </div>
  );
}

function DeptUserSortIcon({ order }) {
  return (
    <div className={"sort-icon userdept " + order}>
      <i className="icon-bsy-iconshangxia" />
      <i className="icon-bsy-sort-asc" />
      <i className="icon-bsy-sort-desc" />
    </div>
  );
}
